webpackJsonp([4,35],{

/***/ 1001:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1032)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1007),
  /* template */
  __webpack_require__(1048),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a19aa926",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1002:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1031)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1008),
  /* template */
  __webpack_require__(1047),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a17e7a24",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1004:
/***/ (function(module, exports) {

module.exports = {template: '<svg width="20" height="15" viewBox="0 0 20 15" xmlns="http://www.w3.org/2000/svg"><path d="M0 14.286h20V0H0v14.286zM16.85 1.65l1.054 1.01-4.701 4.506 4.652 4.46-1.054 1.01-4.652-4.46-2.146 2.057L10 10.23l-.002.002L7.85 8.176l-4.653 4.46-1.054-1.01 4.654-4.46L2.096 2.66l1.053-1.01L10 8.216l6.85-6.566z" fill-rule="evenodd"/></svg>'};

/***/ }),

/***/ 1007:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _Link = __webpack_require__(911);

var _Link2 = _interopRequireDefault(_Link);

var _ProgressiveImage = __webpack_require__(917);

var _ProgressiveImage2 = _interopRequireDefault(_ProgressiveImage);

var _utilities = __webpack_require__(51);

var _lazyloadImage = __webpack_require__(914);

var _lazyloadImage2 = _interopRequireDefault(_lazyloadImage);

var _section = __webpack_require__(912);

var _section2 = _interopRequireDefault(_section);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'article-level-three',
  mixins: [_lazyloadImage2.default, _section2.default],
  props: {
    node: {
      type: Object,
      default: {}
    },
    theme: {
      type: String,
      default: 'default'
    }
  },
  components: {
    NodeLink: _Link2.default,
    ProgressiveImage: _ProgressiveImage2.default
  },
  computed: {
    title: function title() {
      return (0, _utilities.getSocialHeadLingAsTitle)(this.node);
    },
    image: function image() {
      return (0, _get2.default)(this, 'node.images[0]', {});
    },
    destinationTid: function destinationTid() {
      return (0, _get2.default)(this.getLastSection((0, _get2.default)(this, 'node.sections', [])), 'tid', false);
    },
    progressiveImage: function progressiveImage() {
      return {
        src: this.image.style_600x600,
        loading: this.image.style_140x140,
        holder: '/image/placeholder/1/1/5A9CB5/20',
        error: '/image/placeholder/1/1/5A9CB5/20'
      };
    }
  },
  data: function data() {
    return {};
  }
};

/***/ }),

/***/ 1008:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _Link = __webpack_require__(911);

var _Link2 = _interopRequireDefault(_Link);

var _section = __webpack_require__(912);

var _section2 = _interopRequireDefault(_section);

var _utilities = __webpack_require__(51);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'article-level-four',
  mixins: [_section2.default],
  props: {
    node: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    theme: {
      type: String,
      default: 'default'
    }
  },
  components: {
    NodeLink: _Link2.default
  },
  data: function data() {
    return {};
  },

  computed: {
    title: function title() {
      return (0, _utilities.getSocialHeadLingAsTitle)(this.node);
    },
    destinationTid: function destinationTid() {
      return (0, _get2.default)(this.getLastSection((0, _get2.default)(this, 'node.sections', [])), 'tid', false);
    }
  }
};

/***/ }),

/***/ 1011:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Lv = __webpack_require__(1001);

var _Lv2 = _interopRequireDefault(_Lv);

var _Lv3 = __webpack_require__(1002);

var _Lv4 = _interopRequireDefault(_Lv3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'also-read',
  props: {
    article: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    ArticleLevelThree: _Lv2.default,
    ArticleLevelFour: _Lv4.default
  }
};

/***/ }),

/***/ 1012:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1016), __esModule: true };

/***/ }),

/***/ 1013:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1017), __esModule: true };

/***/ }),

/***/ 1014:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(350);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),

/***/ 1015:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(1013);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(1012);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 1016:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(225);
__webpack_require__(150);
module.exports = __webpack_require__(1018);


/***/ }),

/***/ 1017:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(225);
__webpack_require__(150);
module.exports = __webpack_require__(1019);


/***/ }),

/***/ 1018:
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(53);
var get = __webpack_require__(235);
module.exports = __webpack_require__(16).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),

/***/ 1019:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(234);
var ITERATOR = __webpack_require__(17)('iterator');
var Iterators = __webpack_require__(86);
module.exports = __webpack_require__(16).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ 1020:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".also-read-wrapper[data-v-13fa9f8d]{margin-top:1.75rem}@media (min-width:1024px){.also-read-wrapper[data-v-13fa9f8d]{margin-top:2.5rem}}.also-read-article-wrapper[data-v-13fa9f8d],.also-read-wrapper[data-v-13fa9f8d]{margin-bottom:1.75rem}@media (min-width:1024px){.also-read-article-wrapper[data-v-13fa9f8d],.also-read-wrapper[data-v-13fa9f8d]{margin-bottom:2.5rem}}.also-read-tag[data-v-13fa9f8d]{color:#000;position:relative;background-color:#18ffff;text-transform:uppercase;font-weight:700;display:inline-block;font-size:.875rem;line-height:1.625rem;padding:.125rem .75rem 0 1rem;font-family:Barlow,sans-serif}.also-read-tag[data-v-13fa9f8d]:before{width:0;height:0;border-style:solid;border-width:.75rem 0 0 .75rem;border-color:transparent transparent transparent #fff;content:\"\";position:absolute;left:0;bottom:0}.also-read-content[data-v-13fa9f8d]{border-style:solid;border-color:#18ffff;border-width:.25rem 0}", "", {"version":3,"sources":["/app/components/node/AlsoRead.vue"],"names":[],"mappings":"AAgCA,oCACE,kBAAoB,CAErB,AACD,0BACA,oCACM,iBAAmB,CACxB,CACA,AACD,gFAEE,qBAAuB,CAExB,AACD,0BACA,gFAEM,oBAAsB,CAC3B,CACA,AACD,gCACE,WAAe,AACf,kBAAmB,AACnB,yBAA0B,AAC1B,yBAA0B,AAC1B,gBAAkB,AAClB,qBAAsB,AACtB,kBAAoB,AACpB,qBAAsB,AACtB,8BAAiC,AACjC,6BAAkC,CACnC,AACD,uCACI,QAAS,AACT,SAAU,AACV,mBAAoB,AACpB,+BAAkC,AAClC,sDAA0D,AAC1D,WAAY,AACZ,kBAAmB,AACnB,OAAQ,AACR,QAAU,CACb,AACD,oCACE,mBAAoB,AACpB,qBAAsB,AACtB,qBAAwB,CACzB","file":"AlsoRead.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.also-read-wrapper[data-v-13fa9f8d] {\n  margin-top: 1.75rem;\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.also-read-wrapper[data-v-13fa9f8d] {\n      margin-top: 2.5rem;\n}\n}\n.also-read-article-wrapper[data-v-13fa9f8d],\n.also-read-wrapper[data-v-13fa9f8d] {\n  margin-bottom: 1.75rem;\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.also-read-article-wrapper[data-v-13fa9f8d],\n    .also-read-wrapper[data-v-13fa9f8d] {\n      margin-bottom: 2.5rem;\n}\n}\n.also-read-tag[data-v-13fa9f8d] {\n  color: #000000;\n  position: relative;\n  background-color: #18FFFF;\n  text-transform: uppercase;\n  font-weight: bold;\n  display: inline-block;\n  font-size: 0.875rem;\n  line-height: 1.625rem;\n  padding: 0.125rem 0.75rem 0 1rem;\n  font-family: \"Barlow\", sans-serif;\n}\n.also-read-tag[data-v-13fa9f8d]:before {\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-width: 0.75rem 0 0 0.75rem;\n    border-color: transparent transparent transparent #FFFFFF;\n    content: '';\n    position: absolute;\n    left: 0;\n    bottom: 0;\n}\n.also-read-content[data-v-13fa9f8d] {\n  border-style: solid;\n  border-color: #18FFFF;\n  border-width: 0.25rem 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1023:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".article-level-four[data-v-a17e7a24]{font-family:Barlow,sans-serif}.article-level-four.theme-dark .card-title a[data-v-a17e7a24]{color:#fff}.article-level-four .card[data-v-a17e7a24]{border:none;background-color:transparent}@media (min-width:1024px){.article-level-four .card-block[data-v-a17e7a24]{padding:.625rem 0 .875rem}}@media (min-width:0) and (max-width:1023px){.article-level-four .card-block[data-v-a17e7a24]{padding:.5rem 0 .75rem}}.article-level-four .card-title[data-v-a17e7a24]{margin-bottom:0}.article-level-four .card-title a[data-v-a17e7a24]{color:#000;font-weight:700;padding-bottom:.125rem}@media (min-width:1024px){.article-level-four .card-title a[data-v-a17e7a24]{font-size:1.75rem;line-height:2.125rem}}@media (min-width:0) and (max-width:1023px){.article-level-four .card-title a[data-v-a17e7a24]{font-size:1.25rem;line-height:1.625rem}}.article-level-four .card-title a.theme-dark[data-v-a17e7a24]{color:#fff}", "", {"version":3,"sources":["/app/components/article-levels/Lv4.vue"],"names":[],"mappings":"AAgCA,qCACE,6BAAkC,CACnC,AACD,8DACI,UAAe,CAClB,AACD,2CACI,YAAa,AACb,4BAA8B,CACjC,AAKD,0BACA,iDACQ,yBAA6B,CACpC,CACA,AACD,4CACA,iDACQ,sBAA0B,CACjC,CACA,AACD,iDACI,eAAiB,CACpB,AACD,mDAGM,WAAe,AACf,gBAAkB,AAClB,sBAAyB,CAC9B,AACD,0BACA,mDACU,kBAAmB,AACnB,oBAAsB,CAC/B,CACA,AACD,4CACA,mDACU,kBAAmB,AACnB,oBAAsB,CAC/B,CACA,AACD,8DACQ,UAAe,CACtB","file":"Lv4.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.article-level-four[data-v-a17e7a24] {\n  font-family: \"Barlow\", sans-serif;\n}\n.article-level-four.theme-dark .card-title a[data-v-a17e7a24] {\n    color: #FFFFFF;\n}\n.article-level-four .card[data-v-a17e7a24] {\n    border: none;\n    background-color: transparent;\n}\n.article-level-four .card-block[data-v-a17e7a24] {\n    /* Mobile breakpoints */\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.article-level-four .card-block[data-v-a17e7a24] {\n        padding: 0.625rem 0 0.875rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.article-level-four .card-block[data-v-a17e7a24] {\n        padding: 0.5rem 0 0.75rem;\n}\n}\n.article-level-four .card-title[data-v-a17e7a24] {\n    margin-bottom: 0;\n}\n.article-level-four .card-title a[data-v-a17e7a24] {\n      /* Mobile breakpoints */\n      /* Mobile breakpoints */\n      color: #000000;\n      font-weight: bold;\n      padding-bottom: 0.125rem;\n}\n@media (min-width: 1024px) {\n.article-level-four .card-title a[data-v-a17e7a24] {\n          font-size: 1.75rem;\n          line-height: 2.125rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.article-level-four .card-title a[data-v-a17e7a24] {\n          font-size: 1.25rem;\n          line-height: 1.625rem;\n}\n}\n.article-level-four .card-title a.theme-dark[data-v-a17e7a24] {\n        color: #FFFFFF;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1024:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".article-level-three[data-v-a19aa926]{font-family:Barlow,sans-serif}.article-level-three.theme-dark .card-title[data-v-a19aa926]{color:#fff}.article-level-three .card[data-v-a19aa926]{border:none;background-color:transparent}.article-level-three .card a[data-v-a19aa926]{min-height:1px}.article-level-three .card img[data-v-a19aa926]{width:100%;height:auto}.article-level-three a:focus img[data-v-a19aa926],.article-level-three a:hover img[data-v-a19aa926]{-webkit-filter:brightness(70%);color:#fff}@media (min-width:1024px){.article-level-three .card-block[data-v-a19aa926]{padding:.625rem 0 .875rem}}@media (min-width:0) and (max-width:1023px){.article-level-three .card-block[data-v-a19aa926]{padding:.5rem 0 .625rem}}.article-level-three .card-title[data-v-a19aa926]{margin-bottom:0;color:#000;font-weight:700;padding-bottom:.125rem}@media (min-width:1024px){.article-level-three .card-title[data-v-a19aa926]{font-size:1.75rem;line-height:2.125rem}}@media (min-width:0) and (max-width:1023px){.article-level-three .card-title[data-v-a19aa926]{font-size:1.25rem;line-height:1.625rem}}", "", {"version":3,"sources":["/app/components/article-levels/Lv3.vue"],"names":[],"mappings":"AAgCA,sCACE,6BAAkC,CACnC,AACD,6DACI,UAAe,CAClB,AACD,4CACI,YAAa,AACb,4BAA8B,CACjC,AACD,8CACM,cAAgB,CACrB,AACD,gDACM,WAAY,AACZ,WAAa,CAClB,AACD,oGACI,+BAAgC,AAChC,UAAe,CAClB,AAKD,0BACA,kDACQ,yBAA6B,CACpC,CACA,AACD,4CACA,kDACQ,uBAA2B,CAClC,CACA,AACD,kDACI,gBAAiB,AAGjB,WAAe,AACf,gBAAkB,AAClB,sBAAyB,CAC5B,AACD,0BACA,kDACQ,kBAAmB,AACnB,oBAAsB,CAC7B,CACA,AACD,4CACA,kDACQ,kBAAmB,AACnB,oBAAsB,CAC7B,CACA","file":"Lv3.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.article-level-three[data-v-a19aa926] {\n  font-family: \"Barlow\", sans-serif;\n}\n.article-level-three.theme-dark .card-title[data-v-a19aa926] {\n    color: #FFFFFF;\n}\n.article-level-three .card[data-v-a19aa926] {\n    border: none;\n    background-color: transparent;\n}\n.article-level-three .card a[data-v-a19aa926] {\n      min-height: 1px;\n}\n.article-level-three .card img[data-v-a19aa926] {\n      width: 100%;\n      height: auto;\n}\n.article-level-three a:hover img[data-v-a19aa926], .article-level-three a:focus img[data-v-a19aa926] {\n    -webkit-filter: brightness(70%);\n    color: #FFFFFF;\n}\n.article-level-three .card-block[data-v-a19aa926] {\n    /* Mobile breakpoints */\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.article-level-three .card-block[data-v-a19aa926] {\n        padding: 0.625rem 0 0.875rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.article-level-three .card-block[data-v-a19aa926] {\n        padding: 0.5rem 0 0.625rem;\n}\n}\n.article-level-three .card-title[data-v-a19aa926] {\n    margin-bottom: 0;\n    /* Mobile breakpoints */\n    /* Mobile breakpoints */\n    color: #000000;\n    font-weight: bold;\n    padding-bottom: 0.125rem;\n}\n@media (min-width: 1024px) {\n.article-level-three .card-title[data-v-a19aa926] {\n        font-size: 1.75rem;\n        line-height: 2.125rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.article-level-three .card-title[data-v-a19aa926] {\n        font-size: 1.25rem;\n        line-height: 1.625rem;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1028:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1020);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("586dd008", content, true, {});

/***/ }),

/***/ 1031:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1023);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("44893320", content, true, {});

/***/ }),

/***/ 1032:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1024);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("611cf104", content, true, {});

/***/ }),

/***/ 1035:
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),

/***/ 1043:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1028)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1011),
  /* template */
  __webpack_require__(1044),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-13fa9f8d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1044:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "also-read-wrapper"
  }, [_c('div', {
    class: ("also-read-article-wrapper " + (_vm.article.isLast ? 'last': ''))
  }, [_c('span', {
    staticClass: "also-read-tag"
  }, [_vm._v("also read")]), _c('div', {
    staticClass: "also-read-content",
    attrs: {
      "gtm-event-category": "Scroll Article"
    }
  }, [(_vm.article.layoutType === 3) ? _c('article-level-three', {
    attrs: {
      "node": _vm.article.node
    }
  }) : _c('article-level-four', {
    attrs: {
      "node": _vm.article.node
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 1047:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper article-level-four",
    class: 'theme-' + _vm.theme
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_c('node-link', {
    attrs: {
      "url": _vm.node.relative_url,
      "type": _vm.node.type,
      "nid": _vm.node.nid,
      "title": _vm.node.title,
      "destinationTid": _vm.destinationTid,
      "gtm-on": "click",
      "gtm-event-action": "Scroll Article/Click/Also Read",
      "gtm-event-label": ("" + (_vm.node.relative_url))
    }
  }, [_vm._v(_vm._s(_vm.title))])], 1)])])])
},staticRenderFns: []}

/***/ }),

/***/ 1048:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper article-level-three",
    class: 'theme-' + _vm.theme
  }, [_c('div', {
    staticClass: "card"
  }, [_c('node-link', {
    attrs: {
      "url": _vm.node.relative_url,
      "type": _vm.node.type,
      "nid": _vm.node.nid,
      "title": _vm.node.title,
      "destinationTid": _vm.destinationTid,
      "gtm-on": "click",
      "gtm-event-action": "Scroll Article/Click/Also Read",
      "gtm-event-label": ("" + (_vm.node.relative_url))
    }
  }, [_c('progressive-image', {
    staticClass: "disable-photoslider",
    attrs: {
      "progressiveImage": _vm.progressiveImage,
      "alt": _vm.image.alt,
      "width": "320",
      "height": "320"
    }
  }), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_vm._v("\n          " + _vm._s(_vm.title) + "\n        ")])])], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1057:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1084)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1064),
  /* template */
  __webpack_require__(1100),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2ff55563",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1058:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utilities = __webpack_require__(51);

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _forEach = __webpack_require__(22);

var _forEach2 = _interopRequireDefault(_forEach);

var _forEachRight = __webpack_require__(1094);

var _forEachRight2 = _interopRequireDefault(_forEachRight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  methods: {
    repositionOverlappingQuotes: function repositionOverlappingQuotes() {
      if (this.isBodyLeftQuoteMode) {
        var quotesList = document.querySelectorAll('.article-body-blockquote');

        if (quotesList.length !== 0) {
          this.moveDownOverlappingQuotes(quotesList);

          this.moveQuotesWithinContainerLimit(quotesList);
        }
      }
      return false;
    },
    getMoveUpPos: function getMoveUpPos(currentOffsetTop, currentDOMRect, comparedToDOMRect) {
      return (0, _utilities.numberToRem)(currentOffsetTop - ((0, _get2.default)(currentDOMRect, 'bottom', 0) - (0, _get2.default)(comparedToDOMRect, 'top', 0)));
    },
    getMoveDownPos: function getMoveDownPos(currentOffsetTop, currentDOMRect) {
      return (0, _utilities.numberToRem)(currentOffsetTop + (0, _get2.default)(currentDOMRect, 'height', 0));
    },
    moveDownOverlappingQuotes: function moveDownOverlappingQuotes(quotesList) {
      var _this = this;

      (0, _forEach2.default)(quotesList, function (currentBq, index) {
        if (index <= quotesList.length - 1) {
          var nextBq = quotesList[index + 1];
          var currentDOMRect = currentBq ? currentBq.getBoundingClientRect() : false;
          var nextDOMRect = nextBq ? nextBq.getBoundingClientRect() : false;

          if (currentDOMRect) {
            if (nextBq && currentDOMRect.bottom >= nextDOMRect.top) {
              nextBq.style.top = _this.getMoveDownPos(currentBq.offsetTop, currentDOMRect);
            }
          }
        }
      });
    },
    moveQuotesWithinContainerLimit: function moveQuotesWithinContainerLimit(quotesList) {
      var _this2 = this;

      var containerEl = (0, _get2.default)(this, '$refs[articleBody]', false);
      var containerElDOMRect = containerEl ? containerEl.getBoundingClientRect() : false;

      var nonQuoteEl = (0, _get2.default)(document.querySelectorAll('.unblock-left-quote'), '[0]', false);
      var nonQuoteElDOMRect = nonQuoteEl ? nonQuoteEl.getBoundingClientRect() : false;

      if (containerElDOMRect) {
        (0, _forEachRight2.default)(quotesList, function (currentBq, index) {
          if (index <= quotesList.length - 1) {
            var currentDOMRect = currentBq ? currentBq.getBoundingClientRect() : false;

            if (currentDOMRect) {
              if (currentDOMRect.bottom >= containerElDOMRect.bottom) {
                var breaklimitBottomPos = containerElDOMRect.bottom - currentDOMRect.top;
                var moveToBottomPos = currentBq.offsetTop + breaklimitBottomPos;
                var getMoveUpPos = moveToBottomPos - currentDOMRect.height;
                currentBq.style.top = (0, _utilities.numberToRem)(getMoveUpPos);
              }
            }
          }
        });

        if (nonQuoteElDOMRect) {
          (0, _forEachRight2.default)(quotesList, function (currentBq, index) {
            if (index <= quotesList.length - 1) {
              var prevBq = quotesList[index - 1];
              var nextBq = quotesList[index + 1];
              var currentDOMRect = currentBq ? currentBq.getBoundingClientRect() : false;
              var nextDOMRect = nextBq ? nextBq.getBoundingClientRect() : false;

              if (currentDOMRect) {
                if (currentDOMRect.bottom >= nonQuoteElDOMRect.top && currentDOMRect.top <= nonQuoteElDOMRect.bottom) {
                  currentBq.style.top = currentDOMRect.bottom >= nextDOMRect.top ? _this2.getMoveUpPos(currentBq.offsetTop, currentDOMRect, nextDOMRect) : _this2.getMoveUpPos(currentBq.offsetTop, currentDOMRect, nonQuoteElDOMRect);
                } else if (prevBq && currentDOMRect.bottom >= nextDOMRect.top) {
                  currentBq.style.top = _this2.getMoveUpPos(currentBq.offsetTop, currentDOMRect, nextDOMRect);
                }
              }
            }
          });
        }

        (0, _forEachRight2.default)(quotesList, function (currentBq, index) {
          if (index <= quotesList.length - 1) {
            var nextBq = quotesList[index + 1];
            var currentDOMRect = currentBq ? currentBq.getBoundingClientRect() : false;
            var nextDOMRect = nextBq ? nextBq.getBoundingClientRect() : false;

            if (currentDOMRect && nextDOMRect) {
              if (currentDOMRect.bottom >= nextDOMRect.top) {
                currentBq.style.top = _this2.getMoveUpPos(currentBq.offsetTop, currentDOMRect, nextDOMRect);
              }
            }
          }
        });

        (0, _forEach2.default)(quotesList, function (currentBq, index) {
          if (index <= quotesList.length - 1) {
            var currentDOMRect = currentBq ? currentBq.getBoundingClientRect() : false;

            if (currentDOMRect) {
              if (currentDOMRect.top <= containerElDOMRect.top) {
                var breaklimitTopPos = containerElDOMRect.top - currentDOMRect.top;
                var moveToTopPos = currentBq.offsetTop + breaklimitTopPos;
                currentBq.style.top = (0, _utilities.numberToRem)(moveToTopPos);
              }
            }
          }
        });

        this.moveDownOverlappingQuotes(quotesList);

        if (nonQuoteElDOMRect) {
          (0, _forEach2.default)(quotesList, function (currentBq, index) {
            if (index <= quotesList.length - 1) {
              var currentDOMRect = currentBq ? currentBq.getBoundingClientRect() : false;

              if (currentDOMRect) {
                if (currentDOMRect.bottom >= containerElDOMRect.bottom) {
                  if (currentDOMRect.bottom >= nonQuoteElDOMRect.top && currentDOMRect.top <= nonQuoteElDOMRect.bottom) {
                    var breaklimitBottomPos = currentDOMRect.bottom - nonQuoteElDOMRect.top;
                    var moveToBottomPos = nonQuoteEl.offsetTop + breaklimitBottomPos;
                    nonQuoteEl.style.top = (0, _utilities.numberToRem)(moveToBottomPos);
                  }
                }
              }
            }
          });
        }
      }
    }
  }
};

/***/ }),

/***/ 1059:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _isEmpty = __webpack_require__(23);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _forEach = __webpack_require__(22);

var _forEach2 = _interopRequireDefault(_forEach);

var _words = __webpack_require__(361);

var _words2 = _interopRequireDefault(_words);

var _head = __webpack_require__(145);

var _head2 = _interopRequireDefault(_head);

var _includes = __webpack_require__(73);

var _includes2 = _interopRequireDefault(_includes);

var _eventBus = __webpack_require__(224);

var _eventBus2 = _interopRequireDefault(_eventBus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mounted: function mounted() {
    var self = this;

    if ((0, _get2.default)(self, 'getBodyOptions.photoOverlay', false)) {
      var fetchPhotos = [];
      if (!(0, _isEmpty2.default)(self.node.images)) {
        var attrTitle = '';
        (0, _forEach2.default)(self.$refs.articleBody.querySelectorAll('.article-body img'), function (v) {
          if (!(0, _includes2.default)(v.classList, 'disable-photoslider')) {
            attrTitle = v.getAttribute('title') || '';

            var imgSrc = v.parentNode.className.match(/colorbox/i) ? (0, _words2.default)(v.parentNode.getAttribute('href'), /\/[0-9]{4}\/[0-9]{2}\/[0-9]{2}\/.*?\.(jpg|jpeg|png|gif)/i) : (0, _words2.default)(v.getAttribute('tmp-src'), /\/[0-9]{4}\/[0-9]{2}\/[0-9]{2}\/.*?\.(jpg|jpeg|png|gif)/i);
            imgSrc = (0, _head2.default)(imgSrc) || false;
            if (imgSrc) {
              (0, _forEach2.default)(self.node.images, function (images) {
                var image = (0, _words2.default)(images.style_1320w, /\/[0-9]{4}\/[0-9]{2}\/[0-9]{2}\/.*?\.(jpg|jpeg|png|gif)/i);
                image = (0, _head2.default)(image) || false;
                if (v.parentNode.className.match(/colorbox/i) && imgSrc === image) {
                  fetchPhotos.push({ title: attrTitle, caption: attrTitle, enlarge: images.style_1320w, el: v });
                } else if (image === imgSrc) {
                  fetchPhotos.push({ title: attrTitle, caption: attrTitle, enlarge: images.style_1320w, el: v });
                }
              });
            }
          }
        });

        if (!(0, _isEmpty2.default)(fetchPhotos)) {
          (0, _forEach2.default)(fetchPhotos, function (v, i) {
            v.el.onclick = function (e) {
              e.preventDefault();
              _eventBus2.default.$emit('openPhotoSlider', i, false, fetchPhotos, self.node.title);
            };
          });
          var getPhotoFromUrl = (0, _get2.default)(this, '$route.fullPath').match(/(photo)\/(\d{1,2})\/?/);
          if (getPhotoFromUrl) {
            _eventBus2.default.$emit('openPhotoSlider', parseInt(getPhotoFromUrl[2], 0) - 1, false, fetchPhotos, self.node.title);
          }
        }
      }
    }
  }
};

/***/ }),

/***/ 1060:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(1015);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _defineProperty2 = __webpack_require__(1014);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _vueResize = __webpack_require__(338);

var _eventBus = __webpack_require__(224);

var _eventBus2 = _interopRequireDefault(_eventBus);

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _find = __webpack_require__(228);

var _find2 = _interopRequireDefault(_find);

var _assignIn2 = __webpack_require__(155);

var _assignIn3 = _interopRequireDefault(_assignIn2);

var _forEach = __webpack_require__(22);

var _forEach2 = _interopRequireDefault(_forEach);

var _reduce3 = __webpack_require__(976);

var _reduce4 = _interopRequireDefault(_reduce3);

var _includes = __webpack_require__(73);

var _includes2 = _interopRequireDefault(_includes);

var _filter = __webpack_require__(156);

var _filter2 = _interopRequireDefault(_filter);

var _map = __webpack_require__(57);

var _map2 = _interopRequireDefault(_map);

var _head = __webpack_require__(145);

var _head2 = _interopRequireDefault(_head);

var _isEmpty = __webpack_require__(23);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _AlsoRead = __webpack_require__(1043);

var _AlsoRead2 = _interopRequireDefault(_AlsoRead);

var _photoSlider = __webpack_require__(1059);

var _photoSlider2 = _interopRequireDefault(_photoSlider);

var _overlappingQuotes = __webpack_require__(1058);

var _overlappingQuotes2 = _interopRequireDefault(_overlappingQuotes);

var _InlineNewsletterForm = __webpack_require__(1057);

var _InlineNewsletterForm2 = _interopRequireDefault(_InlineNewsletterForm);

var _utilities = __webpack_require__(51);

var _Text = __webpack_require__(1097);

var _Text2 = _interopRequireDefault(_Text);

var _Image = __webpack_require__(1096);

var _Image2 = _interopRequireDefault(_Image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'field-body',
  components: {
    AlsoRead: _AlsoRead2.default,
    InlineNewsletterForm: _InlineNewsletterForm2.default,
    BodyText: _Text2.default,
    BodyImage: _Image2.default,
    BodyIframe: function BodyIframe() {
      return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 1167));
    },
    BodyTwitter: function BodyTwitter() {
      return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 1170));
    },
    BodyInstagram: function BodyInstagram() {
      return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 1168));
    },
    BodyChart: function BodyChart() {
      return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1166));
    },
    BodyBlockquote: function BodyBlockquote() {
      return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 1165));
    },
    BodyRelatedWidget: function BodyRelatedWidget() {
      return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 1169));
    },
    ResizeObserver: _vueResize.ResizeObserver
  },
  props: {
    body: [String],
    bodyOptions: Object,
    node: Object
  },
  data: function data() {
    return {
      isDesktop: false
    };
  },

  mixins: [_photoSlider2.default, _overlappingQuotes2.default],
  computed: {
    getNewsLetterType: function getNewsLetterType() {
      return (0, _utilities.getNewsLetterMapping)((0, _get2.default)(this, 'node.sections', {}));
    },
    articleType: function articleType() {
      return (0, _utilities.getArticleType)((0, _get2.default)(this, 'node', {}));
    },
    newsLetterTheme: function newsLetterTheme() {
      switch ((0, _utilities.getArticleType)((0, _get2.default)(this, 'node', {}))) {
        case 'countdown':
          return 'white';
        case 'live':
          return 'white';
        case 'opinion':
          return 'white';
        case 'photo-essay':
          return 'black';
        case 'review':
          return 'white';
        case 'video':
          return 'black';
        default:
          return 'white';
      }
    },
    getBodyOptions: function getBodyOptions() {
      return (0, _assignIn3.default)({
        countDown: false,
        photoOverlay: false,
        inlineNewsletter: true,
        hideParagraphArrow: false,
        alsoRead: {
          enable: true,
          alsoReadLayout: [4, 3, 4, 4, 4],
          insertPosition: [6, 9, 12, 15, 18]
        }
      }, this.bodyOptions);
    },
    filterBody: function filterBody() {
      return this.node.body;
    },
    contentList: function contentList() {
      var counter = {};
      (0, _forEach2.default)((0, _get2.default)(this, 'node.contentList', []), function (value) {
        counter = (0, _assignIn3.default)(counter, (0, _defineProperty3.default)({}, '' + value.type, (0, _get2.default)(counter, '[' + value.type + ']', 0) + 1));
        value.itemTypeIndex = counter['' + value.type];
      });
      return (0, _get2.default)(this, 'node.contentList', []);
    },
    relatedArticles: function relatedArticles() {
      return (0, _get2.default)(this, 'node.related_articles', []);
    },
    isBodyLeftQuoteMode: function isBodyLeftQuoteMode() {
      switch ((0, _get2.default)(this, 'node.type', {})) {
        case 'article':
          {
            var exemptedArticleTypes = ['photo-essay', 'video'];
            return !(0, _includes2.default)(exemptedArticleTypes, (0, _utilities.getArticleType)((0, _get2.default)(this, 'node', {})));
          }
        case 'comparison':
          return false;
        default:
          return false;
      }
    },
    inlineNewsletterIndex: function inlineNewsletterIndex() {
      var contentListLength = this.contentList.length || 0;
      var firstAlsoReadPosition = (0, _get2.default)(this, 'getBodyOptions.alsoRead.insertPosition[0]', false);
      var index = false;
      if (contentListLength) {
        if ((0, _isEmpty2.default)(this.alsoReadArticles)) {
          if (firstAlsoReadPosition) {
            index = contentListLength >= firstAlsoReadPosition ? firstAlsoReadPosition - 1 : contentListLength - 1;
          }
        } else if (this.alsoReadArticles.length === 1) {
          var lastAlsoReadPosition = (0, _get2.default)(this, 'getBodyOptions.alsoRead.insertPosition[0]', false);

          if (lastAlsoReadPosition && contentListLength >= lastAlsoReadPosition + 4) {
            index = contentListLength - 2 - 1;
          }
        }
      }

      while ((0, _get2.default)(this, 'contentList[' + index + '].content.html') && this.contentList[index].content.html.match(/<h[1-5]>(.*)?<\/h[1-5]>/)) {
        index -= 1;
      }return index;
    },
    alsoReadArticlesIndexesAvailable: function alsoReadArticlesIndexesAvailable() {
      var _this = this;

      var bodyOptionPositionsArray = (0, _get2.default)(this, 'getBodyOptions.alsoRead.insertPosition', []);

      var _reduce = (0, _reduce4.default)(bodyOptionPositionsArray, function (result, position) {
        result[position - 1 <= _this.contentList.length ? 0 : 1].push(position - 1);
        return result;
      }, [[], []]),
          _reduce2 = (0, _slicedToArray3.default)(_reduce, 2),
          pass = _reduce2[0],
          fail = _reduce2[1];

      var indexesAvailableForAlsoRead = { pass: pass, fail: fail };
      return indexesAvailableForAlsoRead;
    },
    alsoReadArticles: function alsoReadArticles() {
      var _this2 = this;

      var isEnabled = (0, _get2.default)(this, 'getBodyOptions.alsoRead.enable', false);
      var alsoReadArticles = [];

      if (isEnabled) {
        var bodyOptionPositionsArray = (0, _get2.default)(this, 'getBodyOptions.alsoRead.insertPosition', []);
        var bodyOptionsLayoutsArray = (0, _get2.default)(this, 'getBodyOptions.alsoRead.alsoReadLayout', []);
        var indexesAvailablePass = (0, _get2.default)(this, 'alsoReadArticlesIndexesAvailable[pass]', []);

        (0, _forEach2.default)(this.relatedArticles, function (article, articleIndex) {
          var getLayoutType = 4;
          var getInsertAtIndex = _this2.contentList.length;
          var getIsIndexAvailable = false;

          (0, _forEach2.default)(bodyOptionsLayoutsArray, function (type, typeIndex) {
            if (articleIndex === typeIndex) {
              getLayoutType = type;
              return false;
            }
            return true;
          });

          (0, _forEach2.default)(bodyOptionPositionsArray, function (position, positionIndex) {
            if (articleIndex === positionIndex) {
              getInsertAtIndex = position - 1;
              return false;
            }
            return true;
          });

          (0, _forEach2.default)(indexesAvailablePass, function (Available) {
            if (getInsertAtIndex === Available) {
              getIsIndexAvailable = true;
              return false;
            }
            return true;
          });

          while ((0, _get2.default)(_this2, 'contentList[' + getInsertAtIndex + '].content.html') && _this2.contentList[getInsertAtIndex].content.html.match(/<h[1-5]>(.*)?<\/h[1-5]>/)) {
            getInsertAtIndex -= 1;
          }var alsoReadDetails = {
            node: article,
            layoutType: getLayoutType,
            insertAtIndex: getInsertAtIndex,
            isIndexAvailable: getIsIndexAvailable,
            isLast: articleIndex === _this2.relatedArticles.length - 1
          };

          alsoReadArticles.push(alsoReadDetails);
        });
      }
      return alsoReadArticles;
    }
  },
  mounted: function mounted() {
    this.isDesktop = (0, _utilities.isDesktop)();

    this.arrowPlacement();
  },
  updated: function updated() {
    this.repositionOverlappingQuotes();
  },

  methods: {
    isShowingWhatisWidget: function isShowingWhatisWidget() {
      var node = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var item = arguments[1];

      var whatisNid = (0, _get2.default)(item, 'content.attr.data-whatis-id', false);
      var whatis = (0, _find2.default)((0, _get2.default)(node, 'what_is_articles', []), ['nid', whatisNid]) || {};
      return (0, _get2.default)(whatis, 'short_title');
    },
    shareData: function shareData() {
      var obj = {
        url: (0, _get2.default)(this.node, 'url', ''),
        shortenUrl: (0, _get2.default)(this.node, 'shorten_url', ''),
        title: (0, _get2.default)(this.node, 'title', '')
      };
      return obj;
    },
    setElementRef: function setElementRef(key, index) {
      return 'processed-' + key + '-' + index;
    },
    arrowPlacement: function arrowPlacement() {
      var _this3 = this;

      if (!this.getBodyOptions.hideParagraphArrow) {
        (0, _forEach2.default)((0, _get2.default)(this, 'contentList', []), function (item, index) {
          if (index === 0 && (0, _get2.default)(item, 'type', '') !== 'image') {
            _this3.addClassToBodyRef(item.type, index, 'arrow-placement');
            return false;
          }

          if ((0, _get2.default)(item, 'type', '') === 'image') {
            var nextIndex = index + 1;
            var nextItem = (0, _get2.default)(_this3, 'contentList[' + nextIndex + ']', false);

            if (nextItem && (0, _get2.default)(nextItem, 'type', '') !== 'image') {
              _this3.addClassToBodyRef(nextItem.type, nextIndex, 'arrow-placement');
              return false;
            }
          }
          return true;
        });
      }
    },
    addClassToBodyRef: function addClassToBodyRef(key, index, className) {
      var referenceElement = (0, _get2.default)(this, '$refs[processed-' + key + '-' + index + ']', false);

      if (referenceElement) {
        var elementClassList = (0, _get2.default)((0, _head2.default)(referenceElement), '$el.classList', false);

        if (elementClassList) {
          elementClassList.add(className);
        }
      }
    },
    resizeBody: function resizeBody() {
      var bq = (0, _map2.default)((0, _filter2.default)(this.$refs, function (element, key) {
        return (0, _includes2.default)(key, 'processed-blockquote-');
      }), '[0].$el');
      this.isDesktop = (0, _utilities.isDesktop)();
      if ((0, _utilities.isDesktop)()) {
        if (bq.length !== 0 && this.isBodyLeftQuoteMode) {
          _eventBus2.default.$emit('repositionQuoteToRelatedEl');
          this.$nextTick(function () {
            this.repositionOverlappingQuotes();
          });
        } else {
          _eventBus2.default.$off('repositionQuoteToRelatedEl');
        }
      }
    }
  }
};

/***/ }),

/***/ 1061:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _head = __webpack_require__(145);

var _head2 = _interopRequireDefault(_head);

var _utilities = __webpack_require__(51);

var _vueResize = __webpack_require__(338);

var _ShareButtons = __webpack_require__(335);

var _ShareButtons2 = _interopRequireDefault(_ShareButtons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'body-image',
  props: ['item', 'type', 'shareData', 'itemIndex', 'inlinePhotoList'],
  data: function data() {
    return {
      imageWrapperHeight: 0
    };
  },

  components: {
    ResizeObserver: _vueResize.ResizeObserver,
    ShareButtons: _ShareButtons2.default
  },
  mounted: function mounted() {
    var _this = this;

    this.$Lazyload.$on('loaded', function (_ref) {
      var el = _ref.el;

      if (el === _this.$refs.lazyload) {
        _this.imageWrapperHeight = 0;
      }
    });
    this.calculateWrapperHeight();
  },

  methods: {
    calculateWrapperHeight: function calculateWrapperHeight() {
      if (this.imageHeight > 0 && this.imageWidth > 0 && this.$refs.container.offsetWidth > 0) {
        if ((0, _utilities.isDesktop)()) {
          this.imageWrapperHeight = 'calc( (' + this.$refs.container.offsetWidth + 'px) * (' + this.imageHeight / this.imageWidth + '))';
        } else {
          this.imageWrapperHeight = 'calc( 100vw * (' + this.imageHeight / this.imageWidth + '))';
        }
      }
    },
    onResize: function onResize() {
      this.calculateWrapperHeight();
    }
  },
  computed: {
    styleObj: function styleObj() {
      var output = {};
      if (this.imageWrapperHeight) {
        output.height = this.imageWrapperHeight;
      }
      return output;
    },
    shareUrl: function shareUrl() {
      return (0, _get2.default)(this, 'inlinePhotoList[' + (this.itemIndex - 1) + '][sizes].style_700x400') ? this.shareData.url + '/photo/' + this.itemIndex : this.shareData.url;
    },
    shareThumbnail: function shareThumbnail() {
      return (0, _get2.default)(this, 'inlinePhotoList[' + (this.itemIndex - 1) + '][sizes].style_700x400');
    },
    imageAttribs: function imageAttribs() {
      return (0, _get2.default)(this, 'item.content.attribs', {});
    },
    imageStyle: function imageStyle() {
      return (0, _get2.default)(this, 'imageAttribs.style', '');
    },
    imageUrl: function imageUrl() {
      return (0, _get2.default)(this, 'imageAttribs.src', '');
    },
    imageHeight: function imageHeight() {
      var height = (0, _get2.default)(this, 'imageAttribs.height', '').replace(/px/g, '');
      if (height.length === 0 && this.imageStyle.length > 0) {
        var styleHeight = (0, _head2.default)(this.imageStyle.match(/height(.*?)px;/g));
        if (styleHeight.length > 0) height = styleHeight.match(/\d/g).join('');
      }
      return height;
    },
    imageWidth: function imageWidth() {
      var width = (0, _get2.default)(this, 'imageAttribs.width', '').replace(/px/g, '');
      if (width.length === 0 && this.imageStyle.length > 0) {
        var styleWidth = (0, _head2.default)(this.imageStyle.match(/width(.*?)px;/g));
        if (styleWidth.length > 0) width = styleWidth.match(/\d/g).join('');
      }
      return width;
    },
    imageClass: function imageClass() {
      return (0, _get2.default)(this, 'imageAttribs.class', '');
    },
    imageDataStyleType: function imageDataStyleType() {
      return (0, _get2.default)(this, 'imageAttribs[\'data-style-type\']', '');
    },
    imageDataWriter: function imageDataWriter() {
      return (0, _get2.default)(this, 'imageAttribs[\'data-writer\']', '');
    },
    imageTitle: function imageTitle() {
      return (0, _get2.default)(this, 'imageAttribs.title', '');
    }
  }
};

/***/ }),

/***/ 1062:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _forEach = __webpack_require__(22);

var _forEach2 = _interopRequireDefault(_forEach);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'body-text',
  props: ['item'],
  mounted: function mounted() {
    var bodyHtml = (0, _get2.default)(this, '$refs[body-html]');

    var currentDomain = (0, _get2.default)(this, '$store.state.requestDomain', '').replace(/^https?:\/\//i, '');
    var regexp = new RegExp(currentDomain, 'gi');

    if (bodyHtml) {
      (0, _forEach2.default)(bodyHtml.querySelectorAll('a'), function (value) {
        if (!value.getAttribute('href').match(regexp) && !value.getAttribute('href').match(/^\//i)) {
          if (!value.getAttribute('href').match(/mailto:/gi)) {
            value.setAttribute('target', '_blank');
          }
        }
      });
    }
  }
};

/***/ }),

/***/ 1063:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _isEmpty = __webpack_require__(23);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _Body = __webpack_require__(951);

var _Body2 = _interopRequireDefault(_Body);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'article-default-body',
  props: ['nid', 'cover'],
  components: {
    FieldBody: _Body2.default
  },
  computed: {
    node: function node() {
      return this.$store.getters.node(this.nid);
    },
    chart: function chart() {
      return {
        options: {
          maintainAspectRatio: false,
          display: true,
          text: 'Chart.js Bar Chart - Stacked',
          responsive: true,
          scales: {
            xAxes: [{
              categorySpacing: 0,
              barPercentage: 1.5
            }],
            yAxes: [{
              type: 'linear',
              display: true,
              position: 'left',
              id: 'y-axis-1'
            }]
          }
        },
        message: 'Hello World',
        labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
        datasets: [{
          label: 'Data One',
          backgroundColor: '#FC2525',
          data: [40, 39, 10, 40, 39, 80, 40]
        }, {
          label: 'Data Two',
          backgroundColor: '#05CBE1',
          data: [60, 55, 32, 10, 2, 12, 53]
        }]
      };
    }
  },
  methods: {
    appendChart: function appendChart() {
      var chartDoms = (0, _get2.default)(this, '$refs.chart.$el');
      if (chartDoms) {
        var chartWrappers = document.querySelectorAll('.node-type-article .article-body .chart');
        if (!(0, _isEmpty2.default)(chartWrappers)) {
          [].forEach.call(chartWrappers, function (targetElement) {
            targetElement.appendChild(chartDoms);
          });
        } else {
          chartDoms.parentElement.removeChild(chartDoms);
        }
      }
    }
  },
  data: function data() {
    return {
      bodyOptions: {
        countDown: true,
        photoOverlay: true,
        hideParagraphArrow: true,
        inlineNewsletter: false
      }
    };
  }
};

/***/ }),

/***/ 1064:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(12);

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _icon_email = __webpack_require__(1004);

var _icon_email2 = _interopRequireDefault(_icon_email);

var _icon_email3 = __webpack_require__(347);

var _icon_email4 = _interopRequireDefault(_icon_email3);

var _newsletter = __webpack_require__(953);

var _newsletter2 = _interopRequireDefault(_newsletter);

var _gtmManager = __webpack_require__(223);

var _gtmManager2 = _interopRequireDefault(_gtmManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_newsletter2.default],
  props: {
    newsletterType: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    theme: {
      type: String,
      default: 'white' }
  },
  data: function data() {
    return {
      color: '#F8008E',
      submit: false,
      email: '',
      warning: false,
      subscition: false,
      lastText: false
    };
  },

  components: {
    SvgEmailLargeIcon: _icon_email2.default,
    SvgEmailIcon: _icon_email4.default
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['showNewsletter']), {
    colorTheme: function colorTheme() {
      var colorTheme = '';
      switch (this.newsletterType.color) {
        case 'blue':
          {
            colorTheme = 'innerbox-blue';
            break;
          }
        case 'yellow':
          {
            colorTheme = 'innerbox-yellow';
            break;
          }
        case 'green':
          {
            colorTheme = 'innerbox-green';
            break;
          }
        default:
          {
            colorTheme = 'innerbox-blue';
          }
      }
      return colorTheme + ' ' + this.theme;
    },
    gtmNewsletterCategory: function gtmNewsletterCategory() {
      var gtmType = 'gtmType_newsletter-inline';
      return (0, _get2.default)(_gtmManager2.default.getDynamicGtmEventsByType(gtmType, {}), 'category', false);
    }
  }),
  methods: {
    afterLeave: function afterLeave() {
      this.subscition = true;
      this.play2();
    },
    afterEnter: function afterEnter() {
      this.subscition = false;
    },
    thankyouEnter: function thankyouEnter() {
      this.lastText = true;
    },
    thankyouLeave: function thankyouLeave() {
      this.lastText = true;
    },
    onSubmit: function onSubmit(e) {
      if (this.validateEmail(this.email)) {
        this.play1();
        this.warning = false;
        this.submit = true;
        e.target.style.display = 'none';
        this.subscribeNewsletter(this.email, this.newsletterType, this.gtmNewsletterCategory);
      } else {
        this.warning = true;
        this.submit = false;
        this.subscition = false;
        e.target.style.display = 'block';
      }
    }
  },
  mounted: function mounted() {
    this.checkSubscribedToList(this.newsletterType);
  }
};

/***/ }),

/***/ 1068:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".newsletter[data-v-2ff55563]{font-family:Barlow,sans-serif;height:14.8125rem}.newsletter.white .newsletter-form[data-v-2ff55563]{background:#fff}.newsletter.white .newsletter-form .title[data-v-2ff55563]{color:#979797}.newsletter.white .newsletter-form .title span[data-v-2ff55563]{color:#000}.newsletter.white .InputEmail[data-v-2ff55563]{background-color:#fff}.newsletter.black .newsletter-form[data-v-2ff55563]{background:#000}.newsletter.black .newsletter-form .title[data-v-2ff55563]{color:#979797}.newsletter.black .newsletter-form .title span[data-v-2ff55563]{color:#fff}.newsletter.black .newsletter-form .InputEmail[data-v-2ff55563]{background-color:#000;color:#fff}.newsletter .nested-border-1.white[data-v-2ff55563],.newsletter .nested-border-2.white[data-v-2ff55563],.newsletter .nested-border-3.white[data-v-2ff55563],.newsletter .nested-border-4.white[data-v-2ff55563],.newsletter .nested-border-5.white[data-v-2ff55563]{border-color:#fff!important}.newsletter .nested-border-1.black[data-v-2ff55563],.newsletter .nested-border-2.black[data-v-2ff55563],.newsletter .nested-border-3.black[data-v-2ff55563],.newsletter .nested-border-4.black[data-v-2ff55563],.newsletter .nested-border-5.black[data-v-2ff55563]{border-color:#000!important}.newsletter .warning[data-v-2ff55563]{margin-top:-.1875rem;margin-bottom:.1875rem;height:1.25rem}.newsletter .warning p[data-v-2ff55563]{background:#ff5cbe;font-size:.75rem;line-height:1.25rem;color:#fff;font-weight:700}.newsletter .mail-icon[data-v-2ff55563]{width:1.5rem;height:1.125rem}.newsletter .newsletter-form[data-v-2ff55563]{position:absolute;top:.4375rem;left:0;right:0;margin:0 auto;margin-right:.4375rem;margin-left:.4375rem;height:10.9375rem}.newsletter .newsletter-form .InputEmail[data-v-2ff55563]{font-family:Barlow,sans-serif;font-size:1.5rem;border-radius:unset;border-bottom:3px solid #979797}.newsletter .newsletter-form .InputEmail.warning-color[data-v-2ff55563]{color:#ff5cbe}.newsletter .newsletter-form .InputEmail[data-v-2ff55563]::-webkit-input-placeholder{color:#ccc;padding-left:.5rem}.newsletter .newsletter-form .InputEmail[data-v-2ff55563]::-moz-placeholder{color:#ccc;padding-left:.5rem}.newsletter .newsletter-form .InputEmail[data-v-2ff55563]:-ms-input-placeholder{color:#ccc;padding-left:.5rem}.newsletter .newsletter-form .InputEmail[data-v-2ff55563]:-moz-placeholder{color:#ccc;padding-left:.5rem}.newsletter .newsletter-form input[data-v-2ff55563]{caret-color:#f8008e;outline-width:2px}.newsletter .newsletter-form .submit-newsletter[data-v-2ff55563]{height:2.5625rem;width:10rem;font-family:Barlow,sans-serif;background:#f8008e;border-radius:unset;color:#fff;font-size:1.125rem;padding-left:2.625rem;padding-right:2.625rem}.newsletter .newsletter-form .submit-newsletter[data-v-2ff55563]:hover{background:#ff5cbe;-webkit-box-shadow:none;box-shadow:none}@media (min-width:0) and (max-width:1023px){.newsletter .newsletter-form .submit-newsletter[data-v-2ff55563]:hover{background:#bf0061}}.newsletter .newsletter-form .submit-newsletter[data-v-2ff55563]:focus{background:#bf0061;-webkit-box-shadow:none;box-shadow:none}.newsletter .newsletter-form .title[data-v-2ff55563]{font-size:.875rem;line-height:1rem;font-weight:700}.newsletter.innerbox-blue[data-v-2ff55563]{background:#00e8ff}.newsletter.innerbox-yellow[data-v-2ff55563]{background:#fceb40}.newsletter.innerbox-green[data-v-2ff55563]{background:#5bf3a6}.newsletter .innerbox[data-v-2ff55563]{height:13.6875rem;border:.1875rem solid;margin:.625rem}.newsletter .innerbox .innerbox[data-v-2ff55563]{height:12.1875rem;position:relative;border:.1875rem solid}.newsletter .innerbox .innerbox .innerbox[data-v-2ff55563]{border:.125rem solid;height:10.4375rem}.newsletter .innerbox .innerbox .innerbox .innerbox[data-v-2ff55563]{border:.0625rem solid;height:8.8125rem}.newsletter .innerbox .innerbox .innerbox .innerbox .innerbox[data-v-2ff55563]{border:.0625rem solid;height:7.3125rem;position:relative}.newsletter .innerbox .innerbox .innerbox .innerbox .innerbox div[data-v-2ff55563]{height:7.3125rem}.newsletter .subscition-box[data-v-2ff55563]{height:11.8125rem;position:absolute;top:.25rem;left:0;right:0;margin:0 auto;height:7.1875rem;width:15.0625rem;top:15%}.newsletter .subscition-box .subscition[data-v-2ff55563]{padding:.625rem}.newsletter .subscition-box .subscition .inner-subscrition[data-v-2ff55563]{height:6.9375rem}.newsletter .subscition-box .subscition .inner-subscrition .mail-icon[data-v-2ff55563]{margin-bottom:.74125rem}.newsletter .subscition-box .subscition .inner-subscrition .subscrition-text[data-v-2ff55563]{font-size:.875rem;line-height:1rem;font-weight:700}@-webkit-keyframes newsletter-zoomIn{0%{opacity:1;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}50%{opacity:1}}@keyframes newsletter-zoomIn-data-v-2ff55563{0%{opacity:1;-webkit-transform:scale3d(.3,.3,.3);transform:scale3d(.3,.3,.3)}50%{opacity:1}}.newsletter .newsletter-zoomIn[data-v-2ff55563]{-webkit-animation-name:newsletter-zoomIn-data-v-2ff55563;animation-name:newsletter-zoomIn-data-v-2ff55563}@-webkit-keyframes newsletter-zoomOut{0%{opacity:1}to{-webkit-transform:scale3d(0,0,0);transform:scale3d(0,0,0);opacity:1}}@keyframes newsletter-zoomOut-data-v-2ff55563{0%{opacity:1}to{-webkit-transform:scale3d(0,0,0);transform:scale3d(0,0,0);opacity:1}}.newsletter .newsletter-zoomOut[data-v-2ff55563]{-webkit-animation-name:newsletter-zoomOut-data-v-2ff55563;animation-name:newsletter-zoomOut-data-v-2ff55563}.newsletter .animated-last[data-v-2ff55563]{-webkit-animation-duration:.8s;animation-duration:.8s;-webkit-animation-fill-mode:both;animation-fill-mode:both}.newsletter .animated-newsletter-form[data-v-2ff55563]{-webkit-animation-duration:.4s;animation-duration:.4s;-webkit-animation-fill-mode:both;animation-fill-mode:both}", "", {"version":3,"sources":["/app/components/widgets/InlineNewsletterForm.vue"],"names":[],"mappings":"AAgCA,6BACE,8BAAkC,AAClC,iBAAmB,CACpB,AACD,oDACI,eAAoB,CACvB,AACD,2DACM,aAAe,CACpB,AACD,gEACQ,UAAe,CACtB,AACD,+CACI,qBAA0B,CAC7B,AACD,oDACI,eAAoB,CACvB,AACD,2DACM,aAAe,CACpB,AACD,gEACQ,UAAe,CACtB,AACD,gEACM,sBAA0B,AAC1B,UAAe,CACpB,AACD,oQACI,2BAAiC,CACpC,AACD,oQACI,2BAAiC,CACpC,AACD,sCACI,qBAAuB,AACvB,uBAAyB,AACzB,cAAgB,CACnB,AACD,wCACM,mBAAoB,AACpB,iBAAmB,AACnB,oBAAqB,AACrB,WAAe,AACf,eAAkB,CACvB,AACD,wCACI,aAAc,AACd,eAAiB,CACpB,AACD,8CACI,kBAAmB,AACnB,aAAe,AACf,OAAQ,AACR,QAAS,AACT,cAAe,AACf,sBAAwB,AACxB,qBAAuB,AACvB,iBAAmB,CACtB,AACD,0DACM,8BAAkC,AAClC,iBAAkB,AAClB,oBAAqB,AACrB,+BAAiC,CACtC,AACD,wEACQ,aAAe,CACtB,AACD,qFAEQ,WAAe,AACf,kBAAqB,CAC5B,AACD,4EAEQ,WAAe,AACf,kBAAqB,CAC5B,AACD,gFAEQ,WAAe,AACf,kBAAqB,CAC5B,AACD,2EAEQ,WAAe,AACf,kBAAqB,CAC5B,AACD,oDACM,oBAAqB,AACrB,iBAAmB,CACxB,AACD,iEACM,iBAAkB,AAClB,YAAa,AACb,8BAAkC,AAClC,mBAAoB,AACpB,oBAAqB,AACrB,WAAe,AACf,mBAAoB,AACpB,sBAAuB,AACvB,sBAAwB,CAC7B,AACD,uEACQ,mBAAoB,AACpB,wBAAyB,AACjB,eAAiB,CAEhC,AACD,4CACA,uEACY,kBAAoB,CAC/B,CACA,AACD,uEACQ,mBAAoB,AACpB,wBAAyB,AACjB,eAAiB,CAChC,AACD,qDACM,kBAAoB,AACpB,iBAAkB,AAClB,eAAkB,CACvB,AACD,2CACI,kBAAoB,CACvB,AACD,6CACI,kBAAoB,CACvB,AACD,4CACI,kBAAoB,CACvB,AACD,uCACI,kBAAmB,AACnB,sBAAwB,AACxB,cAAiB,CACpB,AACD,iDACM,kBAAmB,AACnB,kBAAmB,AACnB,qBAAwB,CAC7B,AACD,2DACQ,qBAAuB,AACvB,iBAAmB,CAC1B,AACD,qEACU,sBAAwB,AACxB,gBAAkB,CAC3B,AACD,+EACY,sBAAwB,AACxB,iBAAkB,AAClB,iBAAmB,CAC9B,AACD,mFACc,gBAAkB,CAC/B,AACD,6CACI,kBAAmB,AACnB,kBAAmB,AACnB,WAAa,AACb,OAAQ,AACR,QAAS,AACT,cAAe,AACf,iBAAkB,AAClB,iBAAkB,AAClB,OAAS,CACZ,AACD,yDACM,eAAkB,CACvB,AACD,4EACQ,gBAAkB,CACzB,AACD,uFACU,uBAA0B,CACnC,AACD,8FACU,kBAAoB,AACpB,iBAAkB,AAClB,eAAkB,CAC3B,AACD,qCACA,GACI,UAAW,AACX,oCAA0C,AAClC,2BAAkC,CAC7C,AACD,IACI,SAAW,CACd,CACA,AACD,6CACA,GACI,UAAW,AACX,oCAA0C,AAClC,2BAAkC,CAC7C,AACD,IACI,SAAW,CACd,CACA,AACD,gDACI,yDAA0D,AAClD,gDAAkD,CAC7D,AACD,sCACA,GACI,SAAW,CACd,AACD,GACI,iCAAoC,AAC5B,yBAA4B,AACpC,SAAW,CACd,CACA,AACD,8CACA,GACI,SAAW,CACd,AACD,GACI,iCAAoC,AAC5B,yBAA4B,AACpC,SAAW,CACd,CACA,AACD,iDACI,0DAA2D,AACnD,iDAAmD,CAC9D,AACD,4CACI,+BAAiC,AACzB,uBAAyB,AACjC,iCAAkC,AAC1B,wBAA0B,CACrC,AACD,uDACI,+BAAiC,AACzB,uBAAyB,AACjC,iCAAkC,AAC1B,wBAA0B,CACrC","file":"InlineNewsletterForm.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.newsletter[data-v-2ff55563] {\n  font-family: \"Barlow\", sans-serif;\n  height: 14.8125rem;\n}\n.newsletter.white .newsletter-form[data-v-2ff55563] {\n    background: #FFFFFF;\n}\n.newsletter.white .newsletter-form .title[data-v-2ff55563] {\n      color: #979797;\n}\n.newsletter.white .newsletter-form .title span[data-v-2ff55563] {\n        color: #000000;\n}\n.newsletter.white .InputEmail[data-v-2ff55563] {\n    background-color: #FFFFFF;\n}\n.newsletter.black .newsletter-form[data-v-2ff55563] {\n    background: #000000;\n}\n.newsletter.black .newsletter-form .title[data-v-2ff55563] {\n      color: #979797;\n}\n.newsletter.black .newsletter-form .title span[data-v-2ff55563] {\n        color: #FFFFFF;\n}\n.newsletter.black .newsletter-form .InputEmail[data-v-2ff55563] {\n      background-color: #000000;\n      color: #FFFFFF;\n}\n.newsletter .nested-border-1.white[data-v-2ff55563], .newsletter .nested-border-2.white[data-v-2ff55563], .newsletter .nested-border-3.white[data-v-2ff55563], .newsletter .nested-border-4.white[data-v-2ff55563], .newsletter .nested-border-5.white[data-v-2ff55563] {\n    border-color: #FFFFFF !important;\n}\n.newsletter .nested-border-1.black[data-v-2ff55563], .newsletter .nested-border-2.black[data-v-2ff55563], .newsletter .nested-border-3.black[data-v-2ff55563], .newsletter .nested-border-4.black[data-v-2ff55563], .newsletter .nested-border-5.black[data-v-2ff55563] {\n    border-color: #000000 !important;\n}\n.newsletter .warning[data-v-2ff55563] {\n    margin-top: -0.1875rem;\n    margin-bottom: 0.1875rem;\n    height: 1.25rem;\n}\n.newsletter .warning p[data-v-2ff55563] {\n      background: #FF5CBE;\n      font-size: 0.75rem;\n      line-height: 1.25rem;\n      color: #FFFFFF;\n      font-weight: bold;\n}\n.newsletter .mail-icon[data-v-2ff55563] {\n    width: 1.5rem;\n    height: 1.125rem;\n}\n.newsletter .newsletter-form[data-v-2ff55563] {\n    position: absolute;\n    top: 0.4375rem;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n    margin-right: 0.4375rem;\n    margin-left: 0.4375rem;\n    height: 10.9375rem;\n}\n.newsletter .newsletter-form .InputEmail[data-v-2ff55563] {\n      font-family: \"Barlow\", sans-serif;\n      font-size: 1.5rem;\n      border-radius: unset;\n      border-bottom: 3px solid #979797;\n}\n.newsletter .newsletter-form .InputEmail.warning-color[data-v-2ff55563] {\n        color: #FF5CBE;\n}\n.newsletter .newsletter-form .InputEmail[data-v-2ff55563]::-webkit-input-placeholder {\n        /* Chrome/Opera/Safari */\n        color: #cccccc;\n        padding-left: 0.5rem;\n}\n.newsletter .newsletter-form .InputEmail[data-v-2ff55563]::-moz-placeholder {\n        /* Firefox 19+ */\n        color: #cccccc;\n        padding-left: 0.5rem;\n}\n.newsletter .newsletter-form .InputEmail[data-v-2ff55563]:-ms-input-placeholder {\n        /* IE 10+ */\n        color: #cccccc;\n        padding-left: 0.5rem;\n}\n.newsletter .newsletter-form .InputEmail[data-v-2ff55563]:-moz-placeholder {\n        /* Firefox 18- */\n        color: #cccccc;\n        padding-left: 0.5rem;\n}\n.newsletter .newsletter-form input[data-v-2ff55563] {\n      caret-color: #F8008E;\n      outline-width: 2px;\n}\n.newsletter .newsletter-form .submit-newsletter[data-v-2ff55563] {\n      height: 2.5625rem;\n      width: 10rem;\n      font-family: \"Barlow\", sans-serif;\n      background: #F8008E;\n      border-radius: unset;\n      color: #FFFFFF;\n      font-size: 1.125rem;\n      padding-left: 2.625rem;\n      padding-right: 2.625rem;\n}\n.newsletter .newsletter-form .submit-newsletter[data-v-2ff55563]:hover {\n        background: #FF5CBE;\n        -webkit-box-shadow: none;\n                box-shadow: none;\n        /* Mobile breakpoints */\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.newsletter .newsletter-form .submit-newsletter[data-v-2ff55563]:hover {\n            background: #BF0061;\n}\n}\n.newsletter .newsletter-form .submit-newsletter[data-v-2ff55563]:focus {\n        background: #BF0061;\n        -webkit-box-shadow: none;\n                box-shadow: none;\n}\n.newsletter .newsletter-form .title[data-v-2ff55563] {\n      font-size: 0.875rem;\n      line-height: 1rem;\n      font-weight: bold;\n}\n.newsletter.innerbox-blue[data-v-2ff55563] {\n    background: #00E8FF;\n}\n.newsletter.innerbox-yellow[data-v-2ff55563] {\n    background: #FCEB40;\n}\n.newsletter.innerbox-green[data-v-2ff55563] {\n    background: #5BF3A6;\n}\n.newsletter .innerbox[data-v-2ff55563] {\n    height: 13.6875rem;\n    border: 0.1875rem solid;\n    margin: 0.625rem;\n}\n.newsletter .innerbox .innerbox[data-v-2ff55563] {\n      height: 12.1875rem;\n      position: relative;\n      border: 0.1875rem solid;\n}\n.newsletter .innerbox .innerbox .innerbox[data-v-2ff55563] {\n        border: 0.125rem solid;\n        height: 10.4375rem;\n}\n.newsletter .innerbox .innerbox .innerbox .innerbox[data-v-2ff55563] {\n          border: 0.0625rem solid;\n          height: 8.8125rem;\n}\n.newsletter .innerbox .innerbox .innerbox .innerbox .innerbox[data-v-2ff55563] {\n            border: 0.0625rem solid;\n            height: 7.3125rem;\n            position: relative;\n}\n.newsletter .innerbox .innerbox .innerbox .innerbox .innerbox div[data-v-2ff55563] {\n              height: 7.3125rem;\n}\n.newsletter .subscition-box[data-v-2ff55563] {\n    height: 11.8125rem;\n    position: absolute;\n    top: 0.25rem;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n    height: 7.1875rem;\n    width: 15.0625rem;\n    top: 15%;\n}\n.newsletter .subscition-box .subscition[data-v-2ff55563] {\n      padding: 0.625rem;\n}\n.newsletter .subscition-box .subscition .inner-subscrition[data-v-2ff55563] {\n        height: 6.9375rem;\n}\n.newsletter .subscition-box .subscition .inner-subscrition .mail-icon[data-v-2ff55563] {\n          margin-bottom: 0.74125rem;\n}\n.newsletter .subscition-box .subscition .inner-subscrition .subscrition-text[data-v-2ff55563] {\n          font-size: 0.875rem;\n          line-height: 1rem;\n          font-weight: bold;\n}\n@-webkit-keyframes newsletter-zoomIn {\nfrom {\n    opacity: 1;\n    -webkit-transform: scale3d(0.3, 0.3, 0.3);\n            transform: scale3d(0.3, 0.3, 0.3);\n}\n50% {\n    opacity: 1;\n}\n}\n@keyframes newsletter-zoomIn-data-v-2ff55563 {\nfrom {\n    opacity: 1;\n    -webkit-transform: scale3d(0.3, 0.3, 0.3);\n            transform: scale3d(0.3, 0.3, 0.3);\n}\n50% {\n    opacity: 1;\n}\n}\n.newsletter .newsletter-zoomIn[data-v-2ff55563] {\n    -webkit-animation-name: newsletter-zoomIn-data-v-2ff55563;\n            animation-name: newsletter-zoomIn-data-v-2ff55563;\n}\n@-webkit-keyframes newsletter-zoomOut {\nfrom {\n    opacity: 1;\n}\nto {\n    -webkit-transform: scale3d(0, 0, 0);\n            transform: scale3d(0, 0, 0);\n    opacity: 1;\n}\n}\n@keyframes newsletter-zoomOut-data-v-2ff55563 {\nfrom {\n    opacity: 1;\n}\nto {\n    -webkit-transform: scale3d(0, 0, 0);\n            transform: scale3d(0, 0, 0);\n    opacity: 1;\n}\n}\n.newsletter .newsletter-zoomOut[data-v-2ff55563] {\n    -webkit-animation-name: newsletter-zoomOut-data-v-2ff55563;\n            animation-name: newsletter-zoomOut-data-v-2ff55563;\n}\n.newsletter .animated-last[data-v-2ff55563] {\n    -webkit-animation-duration: 0.8s;\n            animation-duration: 0.8s;\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n}\n.newsletter .animated-newsletter-form[data-v-2ff55563] {\n    -webkit-animation-duration: 0.4s;\n            animation-duration: 0.4s;\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1069:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".article-content-wrapper[data-v-4f3ec79e]{font-size:1.125rem;line-height:1.625rem;padding-top:2.5rem;max-width:43.75rem;margin:auto}@media (min-width:0) and (max-width:1023px){.article-content-wrapper[data-v-4f3ec79e]{padding-left:1.25rem;padding-right:1.25rem}}.article-body-wrapper[data-v-4f3ec79e]{width:100%}.article-subheading[data-v-4f3ec79e]{position:relative}@media (min-width:1024px){.article-subheading[data-v-4f3ec79e]{font-size:1.5rem;line-height:2.125rem}}.share-buttons-wrapper .share-button svg[data-v-4f3ec79e]{fill:#f8008e}.tags-wrapper[data-v-4f3ec79e]{padding:1.5625rem .4375rem;border-top:1px solid #979797}.article-body .article-body-text div p[data-v-4f3ec79e]{margin-top:0;margin-bottom:1rem}.article-body .article-body-text:first-child div p[data-v-4f3ec79e]{margin-top:0}@media (min-width:1024px){.article-body .article-body-text p[data-v-4f3ec79e]{font-size:1.125rem;line-height:1.875rem}}.tags-wrapper[data-v-4f3ec79e]{position:relative}", "", {"version":3,"sources":["/app/components/node/page/PageBody.vue"],"names":[],"mappings":"AAgCA,0CACE,mBAAoB,AACpB,qBAAsB,AACtB,mBAAoB,AACpB,mBAAoB,AACpB,WAAa,CAEd,AACD,4CACA,0CACM,qBAAsB,AACtB,qBAAuB,CAC5B,CACA,AACD,uCACE,UAAY,CACb,AACD,qCACE,iBAAmB,CAEpB,AACD,0BACA,qCACM,iBAAkB,AAClB,oBAAsB,CAC3B,CACA,AACD,0DACE,YAAc,CACf,AACD,+BACE,2BAA6B,AAC7B,4BAA8B,CAC/B,AACD,wDACE,aAAc,AACd,kBAAoB,CACrB,AACD,oEACE,YAAc,CACf,AAID,0BACA,oDACM,mBAAoB,AACpB,oBAAsB,CAC3B,CACA,AACD,+BACE,iBAAmB,CACpB","file":"PageBody.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.article-content-wrapper[data-v-4f3ec79e] {\n  font-size: 1.125rem;\n  line-height: 1.625rem;\n  padding-top: 2.5rem;\n  max-width: 43.75rem;\n  margin: auto;\n  /* Mobile breakpoints */\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.article-content-wrapper[data-v-4f3ec79e] {\n      padding-left: 1.25rem;\n      padding-right: 1.25rem;\n}\n}\n.article-body-wrapper[data-v-4f3ec79e] {\n  width: 100%;\n}\n.article-subheading[data-v-4f3ec79e] {\n  position: relative;\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.article-subheading[data-v-4f3ec79e] {\n      font-size: 1.5rem;\n      line-height: 2.125rem;\n}\n}\n.share-buttons-wrapper .share-button svg[data-v-4f3ec79e] {\n  fill: #F8008E;\n}\n.tags-wrapper[data-v-4f3ec79e] {\n  padding: 1.5625rem 0.4375rem;\n  border-top: 1px solid #979797;\n}\n.article-body .article-body-text div p[data-v-4f3ec79e] {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n.article-body .article-body-text:first-child div p[data-v-4f3ec79e] {\n  margin-top: 0;\n}\n.article-body .article-body-text p[data-v-4f3ec79e] {\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.article-body .article-body-text p[data-v-4f3ec79e] {\n      font-size: 1.125rem;\n      line-height: 1.875rem;\n}\n}\n.tags-wrapper[data-v-4f3ec79e] {\n  position: relative;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1070:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".img-caption-processed .image[data-v-54eacdd7]{background-color:rgba(90,156,181,.2);background-clip:content-box}.img-caption-processed img[data-v-54eacdd7]:focus,.img-caption-processed img[data-v-54eacdd7]:hover{-webkit-filter:brightness(70%)}@media (min-width:1024px){.img-caption-processed[data-v-54eacdd7]{margin-top:2.5rem;margin-bottom:2.5rem}}@media (min-width:0) and (max-width:1023px){.img-caption-processed[data-v-54eacdd7]{padding-bottom:.75rem}}.img-caption-processed .photo-share[data-v-54eacdd7]{padding-top:1.25rem}@media (min-width:0) and (max-width:1023px){.img-caption-processed .photo-share[data-v-54eacdd7]{padding-top:1rem;margin:0 1.6875rem}}.img-caption-processed .photo-share[data-v-54eacdd7] .share-button-container.mode-inline .share-buttons-wrapper{width:0}.img-caption-processed .photo-share[data-v-54eacdd7] .share-button-container.mode-inline .share-buttons-wrapper a{padding-right:1.25rem}", "", {"version":3,"sources":["/app/components/node/fields/body-items/Image.vue"],"names":[],"mappings":"AAoCA,+CACI,qCAA0C,AAC1C,2BAA6B,CAChC,AACD,oGACI,8BAAgC,CACnC,AACD,0BACA,wCACM,kBAAmB,AACnB,oBAAsB,CAC3B,CACA,AACD,4CACA,wCACM,qBAAwB,CAC7B,CACA,AACD,qDACI,mBAAqB,CAExB,AACD,4CACA,qDACQ,iBAAkB,AAClB,kBAAoB,CAC3B,CACA,AACD,gHACM,OAAS,CACd,AACD,kHACQ,qBAAuB,CAC9B","file":"Image.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.img-caption-processed[data-v-54eacdd7] {\n  /* Mobile breakpoints */\n  /* Mobile breakpoints */\n}\n.img-caption-processed .image[data-v-54eacdd7] {\n    background-color: rgba(90, 156, 181, 0.2);\n    background-clip: content-box;\n}\n.img-caption-processed img[data-v-54eacdd7]:hover, .img-caption-processed img[data-v-54eacdd7]:focus {\n    -webkit-filter: brightness(70%);\n}\n@media (min-width: 1024px) {\n.img-caption-processed[data-v-54eacdd7] {\n      margin-top: 2.5rem;\n      margin-bottom: 2.5rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.img-caption-processed[data-v-54eacdd7] {\n      padding-bottom: 0.75rem;\n}\n}\n.img-caption-processed .photo-share[data-v-54eacdd7] {\n    padding-top: 1.25rem;\n    /* Mobile breakpoints */\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.img-caption-processed .photo-share[data-v-54eacdd7] {\n        padding-top: 1rem;\n        margin: 0 1.6875rem;\n}\n}\n.img-caption-processed .photo-share[data-v-54eacdd7] .share-button-container.mode-inline .share-buttons-wrapper {\n      width: 0;\n}\n.img-caption-processed .photo-share[data-v-54eacdd7] .share-button-container.mode-inline .share-buttons-wrapper a {\n        padding-right: 1.25rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1072:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, "@media (min-width:0) and (max-width:1023px){.newsletter-form-wrapper{margin-bottom:1.7675rem}}@media (min-width:1024px){.newsletter-form-wrapper{width:33.75rem;margin-bottom:2.5rem}}.article-body{word-wrap:break-word;position:relative}@media (min-width:1024px){.article-body{margin-bottom:2.5rem;font-size:1.25rem;line-height:1.875rem}}@media (min-width:0) and (max-width:1023px){.article-body{margin-bottom:1.75rem}}.article-body div[class$=-wrapper]{margin-bottom:1.75rem;text-align:center}@media (min-width:1024px){.article-body iframe{margin:0 auto 2rem}}@media (min-width:0) and (max-width:1023px){.article-body iframe{margin:0 auto 1.75rem}}.article-body iframe,.article-body img{max-width:100%}.article-body img{height:auto}.also-read-wrapper .also-read-article-wrapper .article-body:nth-child(n+2) .also-read-tag{display:none}.article-body .also-read-article-wrapper{text-align:left}@media (min-width:1024px){.article-body .also-read-article-wrapper{margin:auto;max-width:30rem}.article-body .also-read-article-wrapper .article-level-four .card-title a{font-size:1.5rem;line-height:2.125rem}}.article-body .img-caption-processed{margin-left:-3.125rem;margin-right:-3.125rem}@media (min-width:0) and (max-width:1023px){.article-body .img-caption-processed{margin-left:-1.25rem;margin-right:-1.25rem}.article-body .img-caption-processed figcaption{padding-left:1.25rem;padding-right:1.25rem}}@media (min-width:1024px){.article-body .related-person-wrapper{margin-left:-3.125rem;margin-right:-3.125rem}}@media (min-width:0) and (max-width:1023px){.article-body .related-person-wrapper{margin-left:-1.25rem;margin-right:-1.25rem}}.article-body .no-link{pointer-events:none}.body-components{position:relative}", "", {"version":3,"sources":["/app/components/node/fields/Body.vue"],"names":[],"mappings":"AAoCA,4CACA,yBACM,uBAAyB,CAC9B,CACA,AACD,0BACA,yBACM,eAAgB,AAChB,oBAAsB,CAC3B,CACA,AACD,cACE,qBAAsB,AACtB,iBAAmB,CAGpB,AACD,0BACA,cACM,qBAAsB,AACtB,kBAAmB,AACnB,oBAAsB,CAC3B,CACA,AACD,4CACA,cACM,qBAAuB,CAC5B,CACA,AACD,mCACI,sBAAuB,AACvB,iBAAmB,CACtB,AAKD,0BACA,qBAEQ,kBAAkB,CAGzB,CACA,AACD,4CACA,qBAEQ,qBAAkB,CAGzB,CACA,AACD,uCACI,cAAgB,CACnB,AACD,kBACI,WAAa,CAChB,AACD,0FACI,YAAc,CACjB,AACD,yCACI,eAAiB,CAEpB,AACD,0BACA,yCACQ,YAAa,AACb,eAAiB,CACxB,AACD,2EACU,iBAAkB,AAClB,oBAAsB,CAC/B,CACA,AACD,qCAEI,sBAAuB,AACvB,sBAAwB,CAC3B,AACD,4CACA,qCACQ,qBAAsB,AACtB,qBAAuB,CAC9B,AACD,gDACU,qBAAsB,AACtB,qBAAuB,CAChC,CACA,AAKD,0BACA,sCACQ,sBAAuB,AACvB,sBAAwB,CAC/B,CACA,AACD,4CACA,sCACQ,qBAAsB,AACtB,qBAAuB,CAC9B,CACA,AACD,uBACI,mBAAqB,CACxB,AACD,iBACE,iBAAmB,CACpB","file":"Body.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.newsletter-form-wrapper {\n  /* Mobile breakpoints */\n  /* Mobile breakpoints */\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.newsletter-form-wrapper {\n      margin-bottom: 1.7675rem;\n}\n}\n@media (min-width: 1024px) {\n.newsletter-form-wrapper {\n      width: 33.75rem;\n      margin-bottom: 2.5rem;\n}\n}\n.article-body {\n  word-wrap: break-word;\n  position: relative;\n  /* Mobile breakpoints */\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.article-body {\n      margin-bottom: 2.5rem;\n      font-size: 1.25rem;\n      line-height: 1.875rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.article-body {\n      margin-bottom: 1.75rem;\n}\n}\n.article-body div[class$=\"-wrapper\"] {\n    margin-bottom: 1.75rem;\n    text-align: center;\n}\n.article-body iframe {\n    /* Mobile breakpoints */\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.article-body iframe {\n        margin-top: 0;\n        margin-left: auto;\n        margin-right: auto;\n        margin-bottom: 2rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.article-body iframe {\n        margin-top: 0;\n        margin-left: auto;\n        margin-right: auto;\n        margin-bottom: 1.75rem;\n}\n}\n.article-body iframe, .article-body img {\n    max-width: 100%;\n}\n.article-body img {\n    height: auto;\n}\n.also-read-wrapper .also-read-article-wrapper .article-body:nth-child(n+2) .also-read-tag {\n    display: none;\n}\n.article-body .also-read-article-wrapper {\n    text-align: left;\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.article-body .also-read-article-wrapper {\n        margin: auto;\n        max-width: 30rem;\n}\n.article-body .also-read-article-wrapper .article-level-four .card-title a {\n          font-size: 1.5rem;\n          line-height: 2.125rem;\n}\n}\n.article-body .img-caption-processed {\n    /* Mobile breakpoints */\n    margin-left: -3.125rem;\n    margin-right: -3.125rem;\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.article-body .img-caption-processed {\n        margin-left: -1.25rem;\n        margin-right: -1.25rem;\n}\n.article-body .img-caption-processed figcaption {\n          padding-left: 1.25rem;\n          padding-right: 1.25rem;\n}\n}\n.article-body .related-person-wrapper {\n    /* Mobile breakpoints */\n    /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n.article-body .related-person-wrapper {\n        margin-left: -3.125rem;\n        margin-right: -3.125rem;\n}\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.article-body .related-person-wrapper {\n        margin-left: -1.25rem;\n        margin-right: -1.25rem;\n}\n}\n.article-body .no-link {\n    pointer-events: none;\n}\n.body-components {\n  position: relative;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1073:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".arrow-right-wrapper[data-v-dc463cd0]{position:absolute;left:0;height:1.5625rem;width:.9375rem}.arrow-right-wrapper svg[data-v-dc463cd0]{fill:#f8008e;height:100%;width:100%}@media (min-width:0) and (max-width:1023px){.arrow-right-wrapper[data-v-dc463cd0]{margin-left:-1.25rem}}@media (min-width:1024px){.arrow-right-wrapper[data-v-dc463cd0]{margin-top:.25rem;margin-left:-3.375rem}}@media (min-width:1024px){.center-wrapper[data-v-dc463cd0]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}}.arrow-placement[data-v-dc463cd0]:before{content:\"\";display:block;height:1.5625rem;width:.9375rem;background-image:url(\"/static/svg/raw/icon_arrow_right1.svg\");background-size:contain;position:absolute;left:-3.375rem;margin-top:.25rem}", "", {"version":3,"sources":["/app/components/node/fields/Body.vue"],"names":[],"mappings":"AAgCA,sCACE,kBAAmB,AACnB,OAAQ,AACR,iBAAkB,AAClB,cAAiB,CAGlB,AACD,0CACI,aAAc,AACd,YAAa,AACb,UAAY,CACf,AACD,4CACA,sCACM,oBAAsB,CAC3B,CACA,AACD,0BACA,sCACM,kBAAoB,AACpB,qBAAuB,CAC5B,CACA,AAGD,0BACA,iCACI,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,yBAA0B,AACtB,sBAAuB,AACnB,kBAAoB,CAC/B,CACA,AACD,yCACE,WAAY,AACZ,cAAe,AACf,iBAAkB,AAClB,eAAiB,AACjB,8DAA+D,AAC/D,wBAAyB,AACzB,kBAAmB,AACnB,eAAgB,AAChB,iBAAoB,CACrB","file":"Body.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.arrow-right-wrapper[data-v-dc463cd0] {\n  position: absolute;\n  left: 0;\n  height: 1.5625rem;\n  width: 0.9375rem;\n  /* Mobile breakpoints */\n  /* Mobile breakpoints */\n}\n.arrow-right-wrapper svg[data-v-dc463cd0] {\n    fill: #F8008E;\n    height: 100%;\n    width: 100%;\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.arrow-right-wrapper[data-v-dc463cd0] {\n      margin-left: -1.25rem;\n}\n}\n@media (min-width: 1024px) {\n.arrow-right-wrapper[data-v-dc463cd0] {\n      margin-top: 0.25rem;\n      margin-left: -3.375rem;\n}\n}\n\n/* Mobile breakpoints */\n@media (min-width: 1024px) {\n.center-wrapper[data-v-dc463cd0] {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n}\n}\n.arrow-placement[data-v-dc463cd0]::before {\n  content: \"\";\n  display: block;\n  height: 1.5625rem;\n  width: 0.9375rem;\n  background-image: url(\"/static/svg/raw/icon_arrow_right1.svg\");\n  background-size: contain;\n  position: absolute;\n  left: -3.375rem;\n  margin-top: 0.25rem;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1084:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1068);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("217c2fab", content, true, {});

/***/ }),

/***/ 1085:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1069);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("fd551d86", content, true, {});

/***/ }),

/***/ 1086:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1070);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("0b842c65", content, true, {});

/***/ }),

/***/ 1088:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1072);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("60b0af1b", content, true, {});

/***/ }),

/***/ 1089:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1073);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("0e0f3cca", content, true, {});

/***/ }),

/***/ 1090:
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEachRight` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEachRight(array, iteratee) {
  var length = array == null ? 0 : array.length;

  while (length--) {
    if (iteratee(array[length], length, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEachRight;


/***/ }),

/***/ 1091:
/***/ (function(module, exports, __webpack_require__) {

var baseForOwnRight = __webpack_require__(1092),
    createBaseEach = __webpack_require__(358);

/**
 * The base implementation of `_.forEachRight` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEachRight = createBaseEach(baseForOwnRight, true);

module.exports = baseEachRight;


/***/ }),

/***/ 1092:
/***/ (function(module, exports, __webpack_require__) {

var baseForRight = __webpack_require__(1093),
    keys = __webpack_require__(38);

/**
 * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwnRight(object, iteratee) {
  return object && baseForRight(object, iteratee, keys);
}

module.exports = baseForOwnRight;


/***/ }),

/***/ 1093:
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(359);

/**
 * This function is like `baseFor` except that it iterates over properties
 * in the opposite order.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseForRight = createBaseFor(true);

module.exports = baseForRight;


/***/ }),

/***/ 1094:
/***/ (function(module, exports, __webpack_require__) {

var arrayEachRight = __webpack_require__(1090),
    baseEachRight = __webpack_require__(1091),
    castFunction = __webpack_require__(236),
    isArray = __webpack_require__(10);

/**
 * This method is like `_.forEach` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @alias eachRight
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEach
 * @example
 *
 * _.forEachRight([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `2` then `1`.
 */
function forEachRight(collection, iteratee) {
  var func = isArray(collection) ? arrayEachRight : baseEachRight;
  return func(collection, castFunction(iteratee));
}

module.exports = forEachRight;


/***/ }),

/***/ 1096:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1086)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1061),
  /* template */
  __webpack_require__(1102),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-54eacdd7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1097:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1062),
  /* template */
  __webpack_require__(1104),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1098:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1085)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1063),
  /* template */
  __webpack_require__(1101),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4f3ec79e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1100:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showNewsletter) ? _c('div', {
    staticClass: "row newsletter no-gutters w-100 gtm-onElementVisiblity",
    class: _vm.colorTheme,
    attrs: {
      "gtm-on": "elementVisibility",
      "gtm-visibility-category": _vm.gtmNewsletterCategory,
      "gtm-visibility-action": "Newsletter widget impression",
      "gtm-visibility-label": _vm.newsletterType.name
    }
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "innerbox nested-border-1",
    class: _vm.theme
  }, [_c('div', {
    staticClass: "innerbox nested-border-2",
    class: _vm.theme
  }, [_c('transition', {
    attrs: {
      "name": "newsletter-form-transition",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "appear": ""
    }
  }, [(_vm.submit) ? _c('div', {
    staticClass: "innerbox nested-border-3",
    class: _vm.theme
  }, [_c('transition', {
    attrs: {
      "duration": 1000,
      "name": "newsletter-form-transition",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "innerbox nested-border-4",
    class: _vm.theme
  }, [_c('transition', {
    attrs: {
      "duration": 1000,
      "name": "newsletter-form-transition",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated fadeOut",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "innerbox nested-border-5",
    class: _vm.theme
  }, [_c('div')])])], 1)])], 1) : _vm._e()]), _c('transition', {
    attrs: {
      "duration": 1000,
      "name": "newsletter-form-transition",
      "enter-active-class": "animated-newsletter-form newsletter-zoomIn",
      "leave-active-class": "animated-newsletter-form newsletter-zoomOut",
      "appear": ""
    },
    on: {
      "after-enter": _vm.afterEnter,
      "after-leave": _vm.afterLeave
    }
  }, [(!_vm.submit) ? _c('div', {
    staticClass: "newsletter-form p-3"
  }, [_c('form', {
    staticClass: "mx-auto",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "row no-gutters justify-content-between"
  }, [_c('div', {
    staticClass: "col-11"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("GET OUR")]), _c('div', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "text-uppercase"
  }, [_vm._v(_vm._s(_vm.newsletterType.name))]), _vm._v(" NEWSLETTER")])]), _c('div', {
    staticClass: "col-1"
  }, [_c('div', {
    staticClass: "mail-icon float-right"
  }, [_c('svg-email-large-icon', {
    attrs: {
      "fill": _vm.color,
      "width": "100%",
      "height": "100%"
    }
  })], 1)])]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.email),
      expression: "email",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control border-right-0 border-left-0 border-top-0 pl-0 InputEmail",
    class: {
      'warning-color': _vm.warning
    },
    attrs: {
      "type": "email",
      "id": "InputEmail1",
      "placeholder": "your email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _c('div', {
    staticClass: "warning"
  }, [(_vm.warning) ? _c('p', {
    staticClass: "pr-1 pl-1 m-0 h-100"
  }, [_vm._v("Email Address is not valid.")]) : _vm._e()]), _c('button', {
    staticClass: "btn submit-newsletter btn-sm",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("SIGN UP")])])]) : _vm._e()]), (_vm.subscition) ? _c('div', {
    staticClass: "subscition-box"
  }, [_c('div', {
    staticClass: "subscition"
  }, [_c('div', {
    staticClass: "row align-items-center w-100 h-100 no-gutters"
  }, [_c('div', {
    staticClass: "col-12 d-flex align-items-center inner-subscrition"
  }, [_c('div', {
    staticClass: "mx-auto"
  }, [_c('transition', {
    attrs: {
      "name": "newsletter-form-transition",
      "enter-active-class": "animated fadeInUp",
      "leave-active-class": "animated fadeInUP",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "mail-icon mx-auto animated rotateIn"
  }, [_c('svg-email-large-icon', {
    attrs: {
      "fill": _vm.color,
      "width": "100%",
      "height": "100%"
    }
  })], 1)]), _c('div', {
    staticClass: "subscrite"
  }, [_c('transition', {
    attrs: {
      "name": "newsletter-form-transition",
      "enter-active-class": "animated fadeInUp",
      "leave-active-class": "animated fadeInUP",
      "appear": ""
    },
    on: {
      "enter": _vm.thankyouEnter,
      "after-leave": _vm.thankyouLeave
    }
  }, [_c('div', {
    staticClass: "text-center subscrition-text"
  }, [_vm._v("\n                        THANK YOU\n                      ")])]), _c('transition', {
    attrs: {
      "name": "newsletter-form-transition",
      "enter-active-class": "animated-last fadeInUp",
      "leave-active-class": "animated-last fadeInUP",
      "appear": ""
    }
  }, [(_vm.lastText) ? _c('div', {
    staticClass: "text-center subscrition-text"
  }, [_vm._v("\n                        YOU ARE NOW ON THE LIST.\n                      ")]) : _vm._e()])], 1)], 1)])])])]) : _vm._e()], 1)])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1101:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-content-wrapper"
  }, [_c('div', {
    staticClass: "article-body-wrapper"
  }, [_c('field-body', {
    ref: "articleBody",
    attrs: {
      "body": _vm.node.body,
      "node": _vm.node,
      "bodyOptions": _vm.bodyOptions
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1102:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    staticClass: "img-caption-processed"
  }, [_c('resize-observer', {
    on: {
      "notify": _vm.onResize
    }
  }), _c('div', {
    staticClass: "image",
    style: (_vm.styleObj)
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imageUrl),
      expression: "imageUrl"
    }],
    ref: "lazyload",
    class: _vm.imageClass,
    attrs: {
      "data-style-type": _vm.imageDataStyleType,
      "tmp-src": _vm.imageUrl,
      "data-writer": _vm.imageDataWriter,
      "height": _vm.imageHeight,
      "width": _vm.imageWidth,
      "title": _vm.imageTitle
    }
  })]), (_vm.type === 'photo-essay') ? _c('div', {
    staticClass: "photo-share"
  }, [_c('share-buttons', {
    attrs: {
      "url": _vm.shareUrl,
      "title": _vm.imageTitle || _vm.shareData.title,
      "thumbnail": _vm.shareThumbnail,
      "avaliableIcons": {
        pinterest: true,
        email: false,
        whatsapp: false,
        messenger: false
      }
    }
  })], 1) : _vm._e(), (_vm.imageTitle.length > 0) ? _c('figcaption', [_vm._v(_vm._s(_vm.imageTitle))]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1104:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "article-body-text"
  }, [_c('div', {
    ref: "body-html",
    domProps: {
      "innerHTML": _vm._s(_vm.item.content.html)
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 1105:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "body-components",
    staticClass: "body-components"
  }, [_c('resize-observer', {
    on: {
      "notify": _vm.resizeBody
    }
  }), _c('div', {
    ref: "articleBody",
    staticClass: "article-body"
  }, [_vm._l((_vm.contentList), function(item, index) {
    return [(item.type === 'text') ? _c('body-text', {
      ref: _vm.setElementRef('text', index),
      refInFor: true,
      attrs: {
        "item": item,
        "node": _vm.node
      }
    }) : (item.type === 'image') ? _c('body-image', {
      ref: _vm.setElementRef('image', index),
      refInFor: true,
      attrs: {
        "item": item,
        "type": _vm.articleType,
        "shareData": _vm.shareData(),
        "itemIndex": item.itemTypeIndex,
        "inlinePhotoList": _vm.node.inlinePhotoList
      }
    }) : (item.type === 'iframe') ? _c('body-iframe', {
      ref: _vm.setElementRef('iframe', index),
      refInFor: true,
      attrs: {
        "item": item
      }
    }) : (item.type === 'twitter') ? _c('body-twitter', {
      ref: _vm.setElementRef('twitter', index),
      refInFor: true,
      attrs: {
        "item": item
      }
    }) : (item.type === 'instagram') ? _c('body-instagram', {
      ref: _vm.setElementRef('instagram', index),
      refInFor: true,
      attrs: {
        "item": item
      }
    }) : (item.type === 'chart') ? _c('body-chart', {
      ref: _vm.setElementRef('chart', index),
      refInFor: true,
      attrs: {
        "item": item,
        "nid": _vm.node.nid
      }
    }) : (item.type === 'blockquote') ? _c('body-blockquote', {
      ref: _vm.setElementRef('blockquote', index),
      refInFor: true,
      attrs: {
        "item": item,
        "node": _vm.node,
        "isBodyLeftQuoteMode": _vm.isBodyLeftQuoteMode
      }
    }) : (item.type === 'person') ? _c('div', {
      ref: _vm.setElementRef('person', index),
      refInFor: true,
      staticClass: "related-person-group"
    }, [_c('body-related-widget', {
      staticClass: "hidden-sm-down",
      attrs: {
        "item": item,
        "node": _vm.node,
        "theme": "desktop"
      }
    }), _c('body-related-widget', {
      staticClass: "hidden-sm-up",
      attrs: {
        "item": item,
        "node": _vm.node,
        "theme": "mobile"
      }
    })], 1) : (item.type === 'whatis' && _vm.isShowingWhatisWidget(_vm.node, item)) ? _c('div', {
      ref: _vm.setElementRef('whatis', index),
      refInFor: true,
      staticClass: "whatis-widget-group"
    }, [_c('body-related-widget', {
      staticClass: "hidden-sm-down",
      attrs: {
        "item": item,
        "node": _vm.node,
        "theme": "desktop"
      }
    }), _c('body-related-widget', {
      staticClass: "hidden-sm-up",
      attrs: {
        "item": item,
        "node": _vm.node,
        "theme": "mobile"
      }
    })], 1) : _vm._e(), _vm._l((_vm.alsoReadArticles), function(article, articleIndex) {
      return (_vm.getBodyOptions.alsoRead.enable) ? [(article.insertAtIndex === index && article.isIndexAvailable) ? _c('also-read', {
        attrs: {
          "data-index": index,
          "article": article
        }
      }) : _vm._e()] : _vm._e()
    }), (_vm.inlineNewsletterIndex && _vm.inlineNewsletterIndex === index) ? _c('div', {
      staticClass: "center-wrapper hidden-md-up"
    }, [(_vm.getBodyOptions.inlineNewsletter) ? _c('div', {
      staticClass: "newsletter-form-wrapper no-article-gutter-mobile"
    }, [_c('inline-newsletter-form', {
      attrs: {
        "newsletterType": _vm.getNewsLetterType,
        "theme": _vm.newsLetterTheme
      }
    })], 1) : _vm._e()]) : _vm._e()]
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1386:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _PageBody = __webpack_require__(1098);

var _PageBody2 = _interopRequireDefault(_PageBody);

var _Link = __webpack_require__(103);

var _Link2 = _interopRequireDefault(_Link);

var _utilities = __webpack_require__(51);

var _icon_about_us_alien_giant = __webpack_require__(1797);

var _icon_about_us_alien_giant2 = _interopRequireDefault(_icon_about_us_alien_giant);

var _icon_about_us_alien_small_ = __webpack_require__(1798);

var _icon_about_us_alien_small_2 = _interopRequireDefault(_icon_about_us_alien_small_);

var _icon_about_us_alien_small_3 = __webpack_require__(1799);

var _icon_about_us_alien_small_4 = _interopRequireDefault(_icon_about_us_alien_small_3);

var _icon_about_us_alien_small_5 = __webpack_require__(1800);

var _icon_about_us_alien_small_6 = _interopRequireDefault(_icon_about_us_alien_small_5);

var _icon_about_us_alien_small_7 = __webpack_require__(1801);

var _icon_about_us_alien_small_8 = _interopRequireDefault(_icon_about_us_alien_small_7);

var _icon_about_us_alien_small_9 = __webpack_require__(1802);

var _icon_about_us_alien_small_10 = _interopRequireDefault(_icon_about_us_alien_small_9);

var _icon_about_us_alien_small_11 = __webpack_require__(1803);

var _icon_about_us_alien_small_12 = _interopRequireDefault(_icon_about_us_alien_small_11);

var _icon_about_us_alien_small_13 = __webpack_require__(1804);

var _icon_about_us_alien_small_14 = _interopRequireDefault(_icon_about_us_alien_small_13);

var _icon_contact_fb = __webpack_require__(1823);

var _icon_contact_fb2 = _interopRequireDefault(_icon_contact_fb);

var _icon_contact_tw = __webpack_require__(1827);

var _icon_contact_tw2 = _interopRequireDefault(_icon_contact_tw);

var _icon_contact_ig = __webpack_require__(1825);

var _icon_contact_ig2 = _interopRequireDefault(_icon_contact_ig);

var _icon_contact_fb_grey = __webpack_require__(1824);

var _icon_contact_fb_grey2 = _interopRequireDefault(_icon_contact_fb_grey);

var _icon_contact_tw_grey = __webpack_require__(1828);

var _icon_contact_tw_grey2 = _interopRequireDefault(_icon_contact_tw_grey);

var _icon_contact_ig_grey = __webpack_require__(1826);

var _icon_contact_ig_grey2 = _interopRequireDefault(_icon_contact_ig_grey);

var _vuex = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: ['nid'],
  data: function data() {
    return {
      headerBgColor: '#dc3a35',
      navigation: false,
      numOfAlien: 7
    };
  },

  components: {
    TermLink: _Link2.default,
    PageBody: _PageBody2.default,
    SvgAlienGiant: _icon_about_us_alien_giant2.default,
    SvgAlienIcon1: _icon_about_us_alien_small_2.default,
    SvgAlienIcon2: _icon_about_us_alien_small_4.default,
    SvgAlienIcon3: _icon_about_us_alien_small_6.default,
    SvgAlienIcon4: _icon_about_us_alien_small_8.default,
    SvgAlienIcon5: _icon_about_us_alien_small_10.default,
    SvgAlienIcon6: _icon_about_us_alien_small_12.default,
    SvgAlienIcon7: _icon_about_us_alien_small_14.default,
    SvgContactFb: _icon_contact_fb2.default,
    SvgContactTwitter: _icon_contact_tw2.default,
    SvgContactInstagram: _icon_contact_ig2.default,
    SvgContactFbGrey: _icon_contact_fb_grey2.default,
    SvgContactTwitterGrey: _icon_contact_tw_grey2.default,
    SvgContactInstagramGrey: _icon_contact_ig_grey2.default
  },
  computed: (0, _extends3.default)({}, (0, _vuex.mapState)(['termQueue']), {
    node: function node() {
      return this.$store.getters.node(this.nid) || {};
    },
    authorList: function authorList() {
      return (0, _get2.default)(this, 'termQueue.termqueue_abacus_editorial_team_list.content', []);
    }
  }),
  mounted: function mounted() {
    var _this = this;

    (0, _utilities.freezeFixedPosition)(true);
    this.navigation = (0, _get2.default)(this, '$parent.$parent.$refs.header.$refs.navbar.$el', false);
    this.navigation.classList.add('inpage-menu');
    setTimeout(function () {
      _this.navigation.classList.add('inpage');
    }, 800);
  },
  destroyed: function destroyed() {
    (0, _utilities.freezeFixedPosition)(false);
    this.navigation.classList.remove('inpage');
    this.navigation.classList.remove('inpage-menu');
  },

  methods: {
    get: _get2.default,
    socialIcon: function socialIcon(name) {
      return name || '';
    },
    assignAlien: function assignAlien(index) {
      var getAlien = index % this.numOfAlien;
      return 'svg-alien-icon' + (getAlien + 1);
    }
  }
};

/***/ }),

/***/ 1519:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, "#header nav.navigation.inpage{background:#dc3a35}@media (min-width:1024px){#header nav.navigation.inpage-menu{height:4.25rem}#header nav.navigation.inpage-menu .navigation__hamburgerMenu{top:50%;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);height:auto}}", "", {"version":3,"sources":["/app/components/node/page/AboutUs.vue"],"names":[],"mappings":"AAgCA,8BACE,kBAAoB,CACrB,AAID,0BACA,mCACM,cAAgB,CACrB,AACD,8DACQ,QAAS,AACT,mCAAoC,AAChC,+BAAgC,AAC5B,2BAA4B,AACpC,WAAgB,CACvB,CACA","file":"AboutUs.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n#header nav.navigation.inpage {\n  background: #dc3a35;\n}\n#header nav.navigation.inpage-menu {\n  /* Mobile breakpoints */\n}\n@media (min-width: 1024px) {\n#header nav.navigation.inpage-menu {\n      height: 4.25rem;\n}\n#header nav.navigation.inpage-menu .navigation__hamburgerMenu {\n        top: 50%;\n        -webkit-transform: translateY(-50%);\n            -ms-transform: translateY(-50%);\n                transform: translateY(-50%);\n        height: initial;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1520:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".page-static[data-v-7adbe1db]{background:#dc3a35;overflow-x:hidden;padding-bottom:18px}.page-static .top-wrapper[data-v-7adbe1db]{background:#dc3a35;width:100%}.page-static .top-wrapper .title[data-v-7adbe1db]{font-family:Bungee Inline,sans-serif;font-size:8.375rem;color:#fff;max-width:43.75rem;position:relative;margin:auto;padding:6.25rem 0 .625rem;line-height:6.375rem}@media (min-width:0) and (max-width:1023px){.page-static .top-wrapper .title[data-v-7adbe1db]{font-size:2.25rem;padding:4.6875rem 1.6875rem 0;line-height:2.1875rem}}.page-static .node-type-article[data-v-7adbe1db]{font-family:Barlow,sans-serif;color:#fff}.page-static .node-type-article .article-parent-wrapper[data-v-7adbe1db]{position:relative;background:#dc3a35;z-index:1;height:100%}.page-static .email-us-wrapper[data-v-7adbe1db]{margin:auto;position:relative;text-align:center;font-size:1.125rem;padding-bottom:2.5rem}.page-static .email-us-wrapper .email-us-button[data-v-7adbe1db]{width:15rem;height:2.5rem;background:#ffaa9a;color:#dc3a35;display:inline-block;line-height:2.5rem;font-size:1.5rem;font-family:Silkscreen,sans-serif}.page-static .credit-wrapper[data-v-7adbe1db]{position:relative;width:23.4375rem;margin:auto}.page-static .credit-wrapper .monster-head[data-v-7adbe1db]{width:inherit;height:3.125rem}.page-static .credit-wrapper .monster-head .monsters[data-v-7adbe1db]{width:inherit;position:relative}.page-static .credit-wrapper .monster-head .monsters svg[data-v-7adbe1db]{width:inherit;height:auto}.page-static .credit-wrapper .monster-head .monsters .monster-main[data-v-7adbe1db]{width:inherit;fill:#fff;z-index:20;position:relative}.page-static .credit-wrapper .monster-head .monsters .monster-shadow[data-v-7adbe1db]{width:inherit;position:absolute;top:10px;left:10px;fill:#f8008e;z-index:10}.page-static .credit-wrapper .list[data-v-7adbe1db]{background:#6effff;padding:4.5625rem 1.6875rem 1.4375rem;margin-top:4.1875rem}.page-static .credit-wrapper .list .the-team[data-v-7adbe1db]{font-family:Bungee Inline,sans-serif;color:#f8008e;font-size:2.25rem}.page-static .credit-wrapper .list .items[data-v-7adbe1db]{padding-top:1.4375rem}.page-static .credit-wrapper .list .items .item[data-v-7adbe1db]{padding-bottom:.9375rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.page-static .credit-wrapper .list .items .item svg[data-v-7adbe1db]{width:2.0625rem;height:1.5rem}.page-static .credit-wrapper .list .items .item .alien-icon[data-v-7adbe1db]{width:16%;fill:#116564}.page-static .credit-wrapper .list .items .item .equal[data-v-7adbe1db]{width:5%;font-weight:700}.page-static .credit-wrapper .list .items .item .name[data-v-7adbe1db]{width:40%;font-weight:700;font-size:.875rem}.page-static .credit-wrapper .list .items .item .contacts[data-v-7adbe1db]{-webkit-box-flex:1;-ms-flex:1;flex:1;text-align:right}.page-static .credit-wrapper .list .items .item .contacts .contact[data-v-7adbe1db]{display:inline-block;text-align:center;fill:#fff;margin:0 .3125rem;width:1.75rem;height:1.75rem;position:relative}.page-static .credit-wrapper .list .items .item .contacts .contact.dim[data-v-7adbe1db]{opacity:.4}.page-static .credit-wrapper .list .items .item .contacts .contact svg[data-v-7adbe1db]{fill:#fff;width:inherit;height:inherit}.page-static .address-wrapper[data-v-7adbe1db],.page-static .disclaimer-wrapper[data-v-7adbe1db]{max-width:23.4375rem;margin:auto;padding:0 .9375rem}@media (min-width:425px){.page-static .address-wrapper[data-v-7adbe1db],.page-static .disclaimer-wrapper[data-v-7adbe1db]{padding:0}}.page-static .disclaimer-wrapper[data-v-7adbe1db]{margin-top:.625rem;margin-bottom:1.875rem;color:#ffaa9a;font-size:.75rem;line-height:1.25rem;font-style:italic}@media (min-width:440px){.page-static .disclaimer-wrapper[data-v-7adbe1db]{max-width:26.5625rem;text-align:center}}@media (max-width:767px){.page-static .disclaimer-wrapper[data-v-7adbe1db]{margin-bottom:1.25rem}}.page-static .address-wrapper[data-v-7adbe1db]{color:#fff;text-align:center}.page-static .address-wrapper .address__header[data-v-7adbe1db]{font-size:1.1875rem;line-height:1.4375rem;font-weight:700;text-transform:uppercase}.page-static .address-wrapper .address__body[data-v-7adbe1db]{font-size:1.125rem;line-height:1.75rem}.page-static .address-wrapper hr[data-v-7adbe1db]{border-color:#ffaa9a}.page-static .address-wrapper a[data-v-7adbe1db],.page-static .address-wrapper a[data-v-7adbe1db]:active,.page-static .address-wrapper a[data-v-7adbe1db]:focus,.page-static .address-wrapper a[data-v-7adbe1db]:hover{color:#fff;text-decoration:none}.page-static .link--default[data-v-7adbe1db]{cursor:default}", "", {"version":3,"sources":["/app/components/node/page/AboutUs.vue"],"names":[],"mappings":"AAgCA,8BACE,mBAAoB,AACpB,kBAAmB,AACnB,mBAAqB,CACtB,AACD,2CACI,mBAAoB,AACpB,UAAY,CACf,AACD,kDACM,qCAAyC,AACzC,mBAAoB,AACpB,WAAe,AACf,mBAAoB,AACpB,kBAAmB,AACnB,YAAa,AACb,0BAA8B,AAC9B,oBAAsB,CAE3B,AACD,4CACA,kDACU,kBAAmB,AACnB,8BAAyC,AACzC,qBAAuB,CAChC,CACA,AACD,iDACI,8BAAkC,AAClC,UAAe,CAClB,AACD,yEACM,kBAAmB,AACnB,mBAAoB,AACpB,UAAW,AACX,WAAa,CAClB,AACD,gDACI,YAAa,AACb,kBAAmB,AACnB,kBAAmB,AACnB,mBAAoB,AACpB,qBAAuB,CAC1B,AACD,iEACM,YAAa,AACb,cAAe,AACf,mBAAoB,AACpB,cAAe,AACf,qBAAsB,AACtB,mBAAoB,AACpB,iBAAkB,AAClB,iCAAoC,CACzC,AACD,8CACI,kBAAmB,AACnB,iBAAkB,AAClB,WAAa,CAChB,AACD,4DACM,cAAe,AACf,eAAiB,CACtB,AACD,sEACQ,cAAe,AACf,iBAAmB,CAC1B,AACD,0EACU,cAAe,AACf,WAAa,CACtB,AACD,oFACU,cAAe,AACf,UAAc,AACd,WAAY,AACZ,iBAAmB,CAC5B,AACD,sFACU,cAAe,AACf,kBAAmB,AACnB,SAAU,AACV,UAAW,AACX,aAAc,AACd,UAAY,CACrB,AACD,oDACM,mBAAoB,AACpB,sCAAiD,AACjD,oBAAsB,CAC3B,AACD,8DACQ,qCAAyC,AACzC,cAAe,AACf,iBAAmB,CAC1B,AACD,2DACQ,qBAAuB,CAC9B,AACD,iEACU,wBAA0B,AAC1B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,uBAAwB,AACpB,oBAAqB,AACjB,0BAA4B,CAC7C,AACD,qEACY,gBAAiB,AACjB,aAAe,CAC1B,AACD,6EACY,UAAW,AACX,YAAc,CACzB,AACD,wEACY,SAAU,AACV,eAAkB,CAC7B,AACD,uEACY,UAAW,AACX,gBAAkB,AAClB,iBAAoB,CAC/B,AACD,2EACY,mBAAoB,AAChB,WAAY,AACR,OAAQ,AAChB,gBAAkB,CAC7B,AACD,oFACc,qBAAsB,AACtB,kBAAmB,AACnB,UAAc,AACd,kBAAoB,AACpB,cAAe,AACf,eAAgB,AAChB,iBAAmB,CAChC,AACD,wFACgB,UAAY,CAC3B,AACD,wFACgB,UAAc,AACd,cAAe,AACf,cAAgB,CAC/B,AACD,iGAEI,qBAAsB,AACtB,YAAa,AACb,kBAAqB,CACxB,AACD,yBACA,iGAEQ,SAAW,CAClB,CACA,AACD,kDACI,mBAAqB,AACrB,uBAAwB,AACxB,cAAe,AACf,iBAAmB,AACnB,oBAAqB,AACrB,iBAAmB,CAEtB,AACD,yBACA,kDACQ,qBAAsB,AACtB,iBAAmB,CAC1B,CACA,AACD,yBACA,kDACQ,qBAAuB,CAC9B,CACA,AACD,+CACI,WAAe,AACf,iBAAmB,CACtB,AACD,gEACM,oBAAqB,AACrB,sBAAuB,AACvB,gBAAkB,AAClB,wBAA0B,CAC/B,AACD,8DACM,mBAAoB,AACpB,mBAAqB,CAC1B,AACD,kDACM,oBAAsB,CAC3B,AACD,uNACM,WAAe,AACf,oBAAsB,CAC3B,AACD,6CACI,cAAgB,CACnB","file":"AboutUs.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.page-static[data-v-7adbe1db] {\n  background: #dc3a35;\n  overflow-x: hidden;\n  padding-bottom: 18px;\n}\n.page-static .top-wrapper[data-v-7adbe1db] {\n    background: #dc3a35;\n    width: 100%;\n}\n.page-static .top-wrapper .title[data-v-7adbe1db] {\n      font-family: \"Bungee Inline\", sans-serif;\n      font-size: 8.375rem;\n      color: #FFFFFF;\n      max-width: 43.75rem;\n      position: relative;\n      margin: auto;\n      padding: 6.25rem 0 0.625rem 0;\n      line-height: 6.375rem;\n      /* Mobile breakpoints */\n}\n@media (min-width: 0) and (max-width: 1023px) {\n.page-static .top-wrapper .title[data-v-7adbe1db] {\n          font-size: 2.25rem;\n          padding: 4.6875rem 1.6875rem 0 1.6875rem;\n          line-height: 2.1875rem;\n}\n}\n.page-static .node-type-article[data-v-7adbe1db] {\n    font-family: \"Barlow\", sans-serif;\n    color: #FFFFFF;\n}\n.page-static .node-type-article .article-parent-wrapper[data-v-7adbe1db] {\n      position: relative;\n      background: #dc3a35;\n      z-index: 1;\n      height: 100%;\n}\n.page-static .email-us-wrapper[data-v-7adbe1db] {\n    margin: auto;\n    position: relative;\n    text-align: center;\n    font-size: 1.125rem;\n    padding-bottom: 2.5rem;\n}\n.page-static .email-us-wrapper .email-us-button[data-v-7adbe1db] {\n      width: 15rem;\n      height: 2.5rem;\n      background: #FFAA9A;\n      color: #dc3a35;\n      display: inline-block;\n      line-height: 2.5rem;\n      font-size: 1.5rem;\n      font-family: Silkscreen, sans-serif;\n}\n.page-static .credit-wrapper[data-v-7adbe1db] {\n    position: relative;\n    width: 23.4375rem;\n    margin: auto;\n}\n.page-static .credit-wrapper .monster-head[data-v-7adbe1db] {\n      width: inherit;\n      height: 3.125rem;\n}\n.page-static .credit-wrapper .monster-head .monsters[data-v-7adbe1db] {\n        width: inherit;\n        position: relative;\n}\n.page-static .credit-wrapper .monster-head .monsters svg[data-v-7adbe1db] {\n          width: inherit;\n          height: auto;\n}\n.page-static .credit-wrapper .monster-head .monsters .monster-main[data-v-7adbe1db] {\n          width: inherit;\n          fill: #FFFFFF;\n          z-index: 20;\n          position: relative;\n}\n.page-static .credit-wrapper .monster-head .monsters .monster-shadow[data-v-7adbe1db] {\n          width: inherit;\n          position: absolute;\n          top: 10px;\n          left: 10px;\n          fill: #F8008E;\n          z-index: 10;\n}\n.page-static .credit-wrapper .list[data-v-7adbe1db] {\n      background: #6EFFFF;\n      padding: 4.5625rem 1.6875rem 1.4375rem 1.6875rem;\n      margin-top: 4.1875rem;\n}\n.page-static .credit-wrapper .list .the-team[data-v-7adbe1db] {\n        font-family: \"Bungee Inline\", sans-serif;\n        color: #F8008E;\n        font-size: 2.25rem;\n}\n.page-static .credit-wrapper .list .items[data-v-7adbe1db] {\n        padding-top: 1.4375rem;\n}\n.page-static .credit-wrapper .list .items .item[data-v-7adbe1db] {\n          padding-bottom: 0.9375rem;\n          display: -webkit-box;\n          display: -ms-flexbox;\n          display: flex;\n          -webkit-box-pack: start;\n              -ms-flex-pack: start;\n                  justify-content: flex-start;\n}\n.page-static .credit-wrapper .list .items .item svg[data-v-7adbe1db] {\n            width: 2.0625rem;\n            height: 1.5rem;\n}\n.page-static .credit-wrapper .list .items .item .alien-icon[data-v-7adbe1db] {\n            width: 16%;\n            fill: #116564;\n}\n.page-static .credit-wrapper .list .items .item .equal[data-v-7adbe1db] {\n            width: 5%;\n            font-weight: bold;\n}\n.page-static .credit-wrapper .list .items .item .name[data-v-7adbe1db] {\n            width: 40%;\n            font-weight: bold;\n            font-size: 0.875rem;\n}\n.page-static .credit-wrapper .list .items .item .contacts[data-v-7adbe1db] {\n            -webkit-box-flex: 1;\n                -ms-flex: 1;\n                    flex: 1;\n            text-align: right;\n}\n.page-static .credit-wrapper .list .items .item .contacts .contact[data-v-7adbe1db] {\n              display: inline-block;\n              text-align: center;\n              fill: #FFFFFF;\n              margin: 0 0.3125rem;\n              width: 1.75rem;\n              height: 1.75rem;\n              position: relative;\n}\n.page-static .credit-wrapper .list .items .item .contacts .contact.dim[data-v-7adbe1db] {\n                opacity: .4;\n}\n.page-static .credit-wrapper .list .items .item .contacts .contact svg[data-v-7adbe1db] {\n                fill: #FFFFFF;\n                width: inherit;\n                height: inherit;\n}\n.page-static .disclaimer-wrapper[data-v-7adbe1db],\n  .page-static .address-wrapper[data-v-7adbe1db] {\n    max-width: 23.4375rem;\n    margin: auto;\n    padding: 0 0.9375rem;\n}\n@media (min-width: 425px) {\n.page-static .disclaimer-wrapper[data-v-7adbe1db],\n      .page-static .address-wrapper[data-v-7adbe1db] {\n        padding: 0;\n}\n}\n.page-static .disclaimer-wrapper[data-v-7adbe1db] {\n    margin-top: 0.625rem;\n    margin-bottom: 1.875rem;\n    color: #FFAA9A;\n    font-size: 0.75rem;\n    line-height: 1.25rem;\n    font-style: italic;\n    /* Mobile breakpoints */\n}\n@media (min-width: 440px) {\n.page-static .disclaimer-wrapper[data-v-7adbe1db] {\n        max-width: 26.5625rem;\n        text-align: center;\n}\n}\n@media (max-width: 767px) {\n.page-static .disclaimer-wrapper[data-v-7adbe1db] {\n        margin-bottom: 1.25rem;\n}\n}\n.page-static .address-wrapper[data-v-7adbe1db] {\n    color: #FFFFFF;\n    text-align: center;\n}\n.page-static .address-wrapper .address__header[data-v-7adbe1db] {\n      font-size: 1.1875rem;\n      line-height: 1.4375rem;\n      font-weight: bold;\n      text-transform: uppercase;\n}\n.page-static .address-wrapper .address__body[data-v-7adbe1db] {\n      font-size: 1.125rem;\n      line-height: 1.75rem;\n}\n.page-static .address-wrapper hr[data-v-7adbe1db] {\n      border-color: #FFAA9A;\n}\n.page-static .address-wrapper a[data-v-7adbe1db], .page-static .address-wrapper a[data-v-7adbe1db]:hover, .page-static .address-wrapper a[data-v-7adbe1db]:active, .page-static .address-wrapper a[data-v-7adbe1db]:focus {\n      color: #FFFFFF;\n      text-decoration: none;\n}\n.page-static .link--default[data-v-7adbe1db] {\n    cursor: default;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1608:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1519);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("7f2d245e", content, true, {});

/***/ }),

/***/ 1609:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1520);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("04693749", content, true, {});

/***/ }),

/***/ 1767:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "pageWrapper",
    staticClass: "page-static ",
    class: ("page-static-" + _vm.nid)
  }, [_c('div', {
    ref: "pageTopWrapper",
    staticClass: "top-wrapper"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.node.title))])]), _c('article', {
    staticClass: "node node-type-article"
  }, [_c('div', {
    ref: "pageBodyWrapper",
    staticClass: "page-body-wrapper"
  }, [_c('article', {
    staticClass: "node node-type-article"
  }, [_c('div', {
    staticClass: "article-parent-wrapper"
  }, [_c('page-body', {
    attrs: {
      "nid": _vm.nid
    }
  })], 1)])])]), _vm._m(0), _c('div', {
    staticClass: "credit-wrapper"
  }, [_c('div', {
    staticClass: "monster-head"
  }, [_c('div', {
    staticClass: "monsters"
  }, [_c('div', {
    staticClass: "monster-shadow"
  }, [_c('svg-alien-giant')], 1), _c('div', {
    staticClass: "monster-main"
  }, [_c('svg-alien-giant')], 1)])]), _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "the-team"
  }, [_vm._v("THE TEAM")]), _c('div', {
    staticClass: "items"
  }, _vm._l((_vm.authorList), function(value, index) {
    return _c('div', {
      key: "index",
      staticClass: "item"
    }, [_c('div', {
      staticClass: "alien-icon"
    }, [_c(_vm.assignAlien(index), {
      tag: "component",
      attrs: {
        "nid": _vm.nid
      }
    })], 1), _c('div', {
      staticClass: "equal"
    }, [_vm._v("=")]), _c('div', {
      staticClass: "name"
    }, [(value.tid) ? _c('term-link', {
      attrs: {
        "tid": value.tid,
        "title": value.title,
        "url": value.relative_url,
        "type": value.type
      }
    }, [_vm._v(_vm._s(value.title))]) : _vm._e()], 1), _c('div', {
      staticClass: "contacts"
    }, [_c('a', {
      class: {
        'link--default': !_vm.get(value, 'links.facebook')
      },
      attrs: {
        "href": _vm.get(value, 'links.facebook', 'javascript:void(0)'),
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "facebook contact",
      class: {
        dim: !_vm.get(value, 'links.facebook')
      }
    }, [_c(("svg-contact-fb" + (!_vm.get(value, 'links.facebook') ? '-grey' : '')), {
      tag: "component"
    })], 1)]), _c('a', {
      class: {
        'link--default': !_vm.get(value, 'links.twitter')
      },
      attrs: {
        "href": _vm.get(value, 'links.twitter', 'javascript:void(0)'),
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "twitter contact",
      class: {
        dim: !_vm.get(value, 'links.twitter')
      }
    }, [_c(("svg-contact-twitter" + (!_vm.get(value, 'links.twitter') ? '-grey' : '')), {
      tag: "component"
    })], 1)]), _c('a', {
      class: {
        'link--default': !_vm.get(value, 'links.instagram')
      },
      attrs: {
        "href": _vm.get(value, 'links.instagram', 'javascript:void(0)'),
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "instagram contact",
      class: {
        dim: !_vm.get(value, 'links.instagram')
      }
    }, [_c(("svg-contact-instagram" + (!_vm.get(value, 'links.instagram') ? '-grey' : '')), {
      tag: "component"
    })], 1)])])])
  }))])]), _c('div', {
    staticClass: "disclaimer-wrapper"
  }, [_vm._v("Abacus is a unit of the South China Morning Post Publishers Ltd.")]), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "email-us-wrapper"
  }, [_c('a', {
    attrs: {
      "href": "mailto:edt.customerserv@scmp.com"
    }
  }, [_c('div', {
    staticClass: "email-us-button"
  }, [_c('span', [_vm._v("EMAIL US")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "address-wrapper"
  }, [_c('div', {
    staticClass: "address__header"
  }, [_vm._v("South China Morning Post"), _c('br'), _vm._v("Publishers Ltd.")]), _c('hr'), _c('div', {
    staticClass: "address__body"
  }, [_c('div', [_vm._v("19/F., Tower 1, Times Square, 1 Matheson Street, Causeway Bay, Hong Kong")]), _c('a', {
    attrs: {
      "href": "tel:+85225658822"
    }
  }, [_vm._v("(852) 2565 8822")])])])
}]}

/***/ }),

/***/ 1797:
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" width="383" height="173" viewBox="0 0 383 173"><path d="M93.75 94.286V70.714H70.312v23.572H93.75zm70.313 0V70.714h-23.438v23.572h23.438zm70.312 0V70.714h-23.438v23.572h23.438zm70.313 0V70.714H281.25v23.572h23.438zM70.313 165v-23.571H46.874v-23.572H0V94.286h23.438V70.714h23.437V47.143h23.438V23.57h46.874V0h140.625v23.571h46.875v23.572h23.438v23.571h23.438v23.572H375v23.571h-46.875v23.572h-23.438V165H281.25v-23.571h-23.438v-23.572h-46.875v23.572h-46.875v-23.572h-46.875v23.572H93.75V165H70.312z"/></svg>'};

/***/ }),

/***/ 1798:
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" width="33" height="24" viewBox="0 0 33 24"><path fill-rule="evenodd" d="M9 24v-3h6v3H9zm9 0v-3h6v3h-6zm-6-12V9H9v3h3zm12 0V9h-3v3h3zM0 21v-9h3V9h3V6h3V3h3v3h9V3h3v3h3v3h3v3h3v9h-3v-6h-3v6h-3v-3H9v3H6v-6H3v6H0zM6 3V0h3v3H6zm18 0V0h3v3h-3z"/></svg>'};

/***/ }),

/***/ 1799:
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M0 24v-3h3v3H0zm6 0v-3h3v3H6zm9 0v-3h3v3h-3zm6 0v-3h3v3h-3zM3 21v-3h3v3H3zm6 0v-3h6v3H9zm9 0v-3h3v3h-3zm-9-9V9H6v3h3zm9 0V9h-3v3h3zM6 18v-3H0V9h3V6h3V3h3V0h6v3h3v3h3v3h3v6h-6v3h-3v-3H9v3H6z"/></svg>'};

/***/ }),

/***/ 1800:
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" width="30" height="21" viewBox="0 0 30 21"><path fill-rule="evenodd" d="M12 12V9H9v3h3zm9 0V9h-3v3h3zM6 21v-3h3v-3H6v-3H3v6H0V9h3V6h3V3h3V0h3v3h6V0h3v3h3v3h3v3h3v9h-3v-6h-3v3h-3v3h3v3h-6v-6h-6v6H6z"/></svg>'};

/***/ }),

/***/ 1801:
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" width="21" height="24" viewBox="0 0 21 24"><path fill-rule="evenodd" d="M3 24v-3h6v3H3zm9 0v-3h6v3h-6zM0 21v-6h3v6H0zm18 0v-6h3v6h-3zm-9-9V6H6v6h3zm6 0V6h-3v6h3zm-9 6v-3H3v-3H0V6h3V3h15v3h3v6h-3v3h-3v3h-3v-3H9v3H6zM0 3V0h3v3H0zm18 0V0h3v3h-3z"/></svg>'};

/***/ }),

/***/ 1802:
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="24" viewBox="0 0 36 24"><path fill-rule="evenodd" d="M9 24v-3h3v3H9zm15 0v-3h3v3h-3zM6 21v-3h3v3H6zm9 0v-3h6v3h-6zm12 0v-3h3v3h-3zm-12-9V9H9v3h6zm12 0V9h-6v3h6zM9 18v-3H0V6h3V3h9V0h12v3h9v3h3v9h-9v3h-6v-3h-6v3H9z"/></svg>'};

/***/ }),

/***/ 1803:
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" width="27" height="24" viewBox="0 0 27 24"><path fill-rule="evenodd" d="M6 24v-3h6v3H6zm9 0v-3h6v3h-6zM3 21v-3h3v3H3zm18 0v-3h3v3h-3zM6 18v-3h3v3H6zm12 0v-3h3v3h-3zm-6-9V6H6v3h6zm9 0V6h-6v3h6zM9 15v-3H0V6h3V3h3V0h15v3h3v3h3v6h-9v3H9z"/></svg>'};

/***/ }),

/***/ 1804:
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" width="27" height="21" viewBox="0 0 27 21"><path fill-rule="evenodd" d="M3 21v-3h3v3H3zm6 0v-3h3v3H9zm6 0v-3h3v3h-3zm6 0v-3h3v3h-3zM12 9V6H6v3h6zm9 0V6h-6v3h6zM0 18V6h3V3h3V0h3v3h9V0h3v3h3v3h3v12h-3v-3h-3v3h-3v-3h-3v3h-3v-3H9v3H6v-3H3v3H0z"/></svg>'};

/***/ }),

/***/ 1823:
/***/ (function(module, exports) {

module.exports = {template: '<svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><circle fill="#F8008E" cx="14" cy="14" r="14"/><path d="M15.12 11.874h2.343l-.285 2.563H15.12v7.438h-3.07v-7.438H10.5v-2.563h1.55v-1.55c0-1.098.254-1.931.76-2.501.528-.549 1.382-.823 2.564-.823h2.057v2.564h-1.266c-.295 0-.485.02-.57.063-.147.021-.253.084-.316.19-.042.084-.084.19-.127.316 0 .021-.005.085-.015.19-.011.106-.016.19-.016.253v1.298z" fill="#FFF"/></g></svg>'};

/***/ }),

/***/ 1824:
/***/ (function(module, exports) {

module.exports = {template: '<svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><circle fill="#AAA" cx="14" cy="14" r="14"/><path d="M15.12 11.874h2.343l-.285 2.563H15.12v7.438h-3.07v-7.438H10.5v-2.563h1.55v-1.55c0-1.098.254-1.931.76-2.501.528-.549 1.382-.823 2.564-.823h2.057v2.564h-1.266c-.295 0-.485.02-.57.063-.147.021-.253.084-.316.19-.042.084-.084.19-.127.316 0 .021-.005.085-.015.19-.011.106-.016.19-.016.253v1.298z" fill="#FFF"/></g></svg>'};

/***/ }),

/***/ 1825:
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28"><g fill="none" fill-rule="evenodd"><circle cx="14" cy="14" r="14" fill="#F8008E"/><path fill="#FFF" fill-rule="nonzero" d="M16.666 7.06c.64.025 1.199.122 1.662.304.463.207.867.474 1.2.826.355.352.629.753.807 1.226.178.474.273 1.045.296 1.7.036.498.06 1.457.06 2.902 0 1.42-.024 2.38-.06 2.866-.023.655-.118 1.226-.296 1.7a3.592 3.592 0 0 1-.808 1.226 3.292 3.292 0 0 1-1.2.826c-.462.182-1.02.279-1.661.303-.487.037-1.413.061-2.803.061-1.413 0-2.35-.012-2.838-.06-.64-.013-1.199-.122-1.662-.304a3.343 3.343 0 0 1-1.2-.826 3.712 3.712 0 0 1-.807-1.226c-.178-.474-.273-1.045-.297-1.7C7.024 16.386 7 15.439 7 14.018c0-1.445.012-2.404.06-2.902a5.16 5.16 0 0 1 .296-1.7 3.14 3.14 0 0 1 .808-1.226c.356-.34.76-.62 1.199-.826.463-.182 1.021-.279 1.662-.303C11.512 7.024 12.45 7 13.863 7c1.39 0 2.316.024 2.803.06zm-5.581 1.264a4.962 4.962 0 0 0-1.259.218 3.414 3.414 0 0 0-.807.522c-.214.255-.38.534-.511.826-.13.388-.202.813-.214 1.287-.035.498-.06 1.445-.06 2.841 0 1.384.013 2.32.06 2.817.012.474.083.899.214 1.287.119.292.297.571.51.826.19.206.464.376.808.522.38.134.796.206 1.259.243.487.024 1.413.024 2.778.024 1.354 0 2.268-.012 2.755-.024a5.532 5.532 0 0 0 1.259-.243c.332-.146.605-.316.807-.522a2.55 2.55 0 0 0 .51-.826c.12-.388.203-.813.238-1.287.012-.498.024-1.433.024-2.817 0-1.408-.012-2.355-.024-2.841a5.886 5.886 0 0 0-.237-1.287c-.143-.34-.309-.62-.51-.826a2.617 2.617 0 0 0-.808-.522 4.962 4.962 0 0 0-1.259-.218c-.487-.037-1.401-.061-2.755-.061-1.377 0-2.303.024-2.778.06zm5.248 3.12c.689.704 1.033 1.554 1.033 2.55 0 .983-.344 1.821-1.033 2.526-.689.704-1.508 1.056-2.47 1.056-.985 0-1.816-.352-2.493-1.056-.689-.705-1.033-1.543-1.033-2.526 0-.996.344-1.858 1.033-2.55.688-.704 1.52-1.056 2.493-1.056.962.012 1.781.352 2.47 1.056zm-.867 4.201c.44-.449.665-.995.665-1.639 0-.656-.225-1.214-.665-1.663-.451-.45-.985-.68-1.603-.68-.641 0-1.187.23-1.627.68-.45.461-.664 1.007-.664 1.663 0 .644.225 1.19.664 1.64.44.46.986.68 1.627.68.618 0 1.152-.231 1.603-.68zm2.03-6.229a.825.825 0 0 0-.593.243.815.815 0 0 0-.237.607c0 .243.083.437.237.607.166.17.356.243.594.243a.845.845 0 0 0 .593-.243.815.815 0 0 0 .238-.607.885.885 0 0 0-.238-.607.796.796 0 0 0-.593-.243z"/></g></svg>'};

/***/ }),

/***/ 1826:
/***/ (function(module, exports) {

module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28"><g fill="none" fill-rule="evenodd"><circle cx="14" cy="14" r="14" fill="#AAA"/><path fill="#FFF" fill-rule="nonzero" d="M16.666 7.06c.64.025 1.199.122 1.662.304.463.207.867.474 1.2.826.355.352.629.753.807 1.226.178.474.273 1.045.296 1.7.036.498.06 1.457.06 2.902 0 1.42-.024 2.38-.06 2.866-.023.655-.118 1.226-.296 1.7a3.592 3.592 0 0 1-.808 1.226 3.292 3.292 0 0 1-1.2.826c-.462.182-1.02.279-1.661.303-.487.037-1.413.061-2.803.061-1.413 0-2.35-.012-2.838-.06-.64-.013-1.199-.122-1.662-.304a3.343 3.343 0 0 1-1.2-.826 3.712 3.712 0 0 1-.807-1.226c-.178-.474-.273-1.045-.297-1.7C7.024 16.386 7 15.439 7 14.018c0-1.445.012-2.404.06-2.902a5.16 5.16 0 0 1 .296-1.7 3.14 3.14 0 0 1 .808-1.226c.356-.34.76-.62 1.199-.826.463-.182 1.021-.279 1.662-.303C11.512 7.024 12.45 7 13.863 7c1.39 0 2.316.024 2.803.06zm-5.581 1.264a4.962 4.962 0 0 0-1.259.218 3.414 3.414 0 0 0-.807.522c-.214.255-.38.534-.511.826-.13.388-.202.813-.214 1.287-.035.498-.06 1.445-.06 2.841 0 1.384.013 2.32.06 2.817.012.474.083.899.214 1.287.119.292.297.571.51.826.19.206.464.376.808.522.38.134.796.206 1.259.243.487.024 1.413.024 2.778.024 1.354 0 2.268-.012 2.755-.024a5.532 5.532 0 0 0 1.259-.243c.332-.146.605-.316.807-.522a2.55 2.55 0 0 0 .51-.826c.12-.388.203-.813.238-1.287.012-.498.024-1.433.024-2.817 0-1.408-.012-2.355-.024-2.841a5.886 5.886 0 0 0-.237-1.287c-.143-.34-.309-.62-.51-.826a2.617 2.617 0 0 0-.808-.522 4.962 4.962 0 0 0-1.259-.218c-.487-.037-1.401-.061-2.755-.061-1.377 0-2.303.024-2.778.06zm5.248 3.12c.689.704 1.033 1.554 1.033 2.55 0 .983-.344 1.821-1.033 2.526-.689.704-1.508 1.056-2.47 1.056-.985 0-1.816-.352-2.493-1.056-.689-.705-1.033-1.543-1.033-2.526 0-.996.344-1.858 1.033-2.55.688-.704 1.52-1.056 2.493-1.056.962.012 1.781.352 2.47 1.056zm-.867 4.201c.44-.449.665-.995.665-1.639 0-.656-.225-1.214-.665-1.663-.451-.45-.985-.68-1.603-.68-.641 0-1.187.23-1.627.68-.45.461-.664 1.007-.664 1.663 0 .644.225 1.19.664 1.64.44.46.986.68 1.627.68.618 0 1.152-.231 1.603-.68zm2.03-6.229a.825.825 0 0 0-.593.243.815.815 0 0 0-.237.607c0 .243.083.437.237.607.166.17.356.243.594.243a.845.845 0 0 0 .593-.243.815.815 0 0 0 .238-.607.885.885 0 0 0-.238-.607.796.796 0 0 0-.593-.243z"/></g></svg>'};

/***/ }),

/***/ 1827:
/***/ (function(module, exports) {

module.exports = {template: '<svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><circle fill="#F8008E" cx="14" cy="14" r="14"/><path d="M21 9.369a6.407 6.407 0 0 1-1.431 1.462v.373c0 .85-.114 1.618-.342 2.303a7.939 7.939 0 0 1-1.027 2.209c-.394.643-.933 1.275-1.618 1.897a7.36 7.36 0 0 1-2.302 1.276c-.871.332-1.825.498-2.862.498A7.98 7.98 0 0 1 7 18.08c.29.041.519.062.684.062 1.307 0 2.5-.415 3.578-1.244a2.73 2.73 0 0 1-1.68-.56 2.837 2.837 0 0 1-1.026-1.431c.29.041.477.062.56.062.27 0 .518-.042.746-.125-.643-.124-1.192-.445-1.649-.964a2.843 2.843 0 0 1-.653-1.836v-.03c.415.227.85.342 1.307.342a2.69 2.69 0 0 1-.934-.996c-.228-.394-.342-.85-.342-1.369 0-.54.125-1.027.373-1.462a8.058 8.058 0 0 0 2.614 2.115c1.058.54 2.167.84 3.329.903a2.84 2.84 0 0 1-.094-.685c0-.788.28-1.462.84-2.022.56-.56 1.245-.84 2.054-.84.83 0 1.524.3 2.084.902a5.96 5.96 0 0 0 1.836-.684c-.208.684-.633 1.213-1.276 1.586A7.235 7.235 0 0 0 21 9.37z" fill="#FFF"/></g></svg>'};

/***/ }),

/***/ 1828:
/***/ (function(module, exports) {

module.exports = {template: '<svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><circle fill="#AAA" cx="14" cy="14" r="14"/><path d="M21 9.369a6.407 6.407 0 0 1-1.431 1.462v.373c0 .85-.114 1.618-.342 2.303a7.939 7.939 0 0 1-1.027 2.209c-.394.643-.933 1.275-1.618 1.897a7.36 7.36 0 0 1-2.302 1.276c-.871.332-1.825.498-2.862.498A7.98 7.98 0 0 1 7 18.08c.29.041.519.062.684.062 1.307 0 2.5-.415 3.578-1.244a2.73 2.73 0 0 1-1.68-.56 2.837 2.837 0 0 1-1.026-1.431c.29.041.477.062.56.062.27 0 .518-.042.746-.125-.643-.124-1.192-.445-1.649-.964a2.843 2.843 0 0 1-.653-1.836v-.03c.415.227.85.342 1.307.342a2.69 2.69 0 0 1-.934-.996c-.228-.394-.342-.85-.342-1.369 0-.54.125-1.027.373-1.462a8.058 8.058 0 0 0 2.614 2.115c1.058.54 2.167.84 3.329.903a2.84 2.84 0 0 1-.094-.685c0-.788.28-1.462.84-2.022.56-.56 1.245-.84 2.054-.84.83 0 1.524.3 2.084.902a5.96 5.96 0 0 0 1.836-.684c-.208.684-.633 1.213-1.276 1.586A7.235 7.235 0 0 0 21 9.37z" fill="#FFF"/></g></svg>'};

/***/ }),

/***/ 891:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1609)
  __webpack_require__(1608)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1386),
  /* template */
  __webpack_require__(1767),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7adbe1db",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 911:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(12);

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _includes = __webpack_require__(73);

var _includes2 = _interopRequireDefault(_includes);

var _head = __webpack_require__(145);

var _head2 = _interopRequireDefault(_head);

var _has = __webpack_require__(102);

var _has2 = _interopRequireDefault(_has);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'node-link',
  props: {
    title: {
      type: String
    },
    type: {
      type: String
    },
    nid: {
      type: [String, Number]
    },
    url: {
      type: String
    },
    destinationTid: {
      type: [String, Number, Boolean]
    }
  },
  methods: (0, _extends3.default)({}, (0, _vuex.mapMutations)(['setArticleListTid'])),
  render: function render(h) {
    var _this = this;

    var router = this.$router;
    var data = { attrs: { href: this.url } };
    var routeData = {
      type: this.type,
      nid: this.nid,
      url: this.url,
      title: this.title,

      props: {
        nid: this.nid,
        destinationTid: this.destinationTid
      }
    };

    router.addRouteByNode({ routeData: routeData });

    data.on = { click: function click(e) {
        e.preventDefault();
        if (_this.destinationTid) {
          _this.$store.commit('setArticleListTid', _this.destinationTid);

          var route = (0, _get2.default)(_this, '$route', {});
          var components = (0, _get2.default)((0, _head2.default)((0, _get2.default)(route, 'matched', [])), 'components.default.components', false);
          var isArticleToArticle = (0, _has2.default)(components, 'ArticleView');

          if (isArticleToArticle) {
            _this.$store.dispatch('toggleRouteTransition', true);
            _this.$store.commit('setIsRefreshedToRoutedArticle', true);

            if ((0, _includes2.default)(window.location.href, routeData.url)) {
              _this.$store.dispatch('toggleRouteTransition', false);
              _this.$store.commit('setIsRefreshedToRoutedArticle', false);
            }
          }
        }
        router.push(routeData.url);
      } };
    return h('a', data, this.$slots.default);
  }
};

/***/ }),

/***/ 912:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _head = __webpack_require__(145);

var _head2 = _interopRequireDefault(_head);

var _isArray = __webpack_require__(10);

var _isArray2 = _interopRequireDefault(_isArray);

var _last = __webpack_require__(146);

var _last2 = _interopRequireDefault(_last);

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  computed: {
    sectionColor: function sectionColor() {
      if ((0, _get2.default)(this, 'sections')) {
        var section = (0, _last2.default)((0, _head2.default)(this.sections));
        return (0, _get2.default)(section, 'color_info.hex', '');
      }
      return '';
    },
    firstSectionLineage: function firstSectionLineage() {
      var firstLineage = [];
      if ((0, _get2.default)(this, 'sections') && (0, _isArray2.default)(this.sections)) {
        firstLineage = (0, _head2.default)(this.sections);
      }
      return firstLineage;
    },
    firstSection: function firstSection() {
      var section = {};
      if ((0, _isArray2.default)(this.firstSectionLineage)) {
        section = (0, _head2.default)(this.firstSectionLineage);
      }
      return section;
    },
    lastSection: function lastSection() {
      var section = {};
      if ((0, _isArray2.default)(this.firstSectionLineage)) {
        section = (0, _last2.default)(this.firstSectionLineage);
      }
      return section;
    }
  },
  methods: {
    getLastSection: function getLastSection(sections) {
      if (sections && (0, _isArray2.default)(sections)) {
        return (0, _last2.default)((0, _head2.default)(sections));
      }
      return false;
    }
  }
};

/***/ }),

/***/ 914:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  methods: {
    getArticleLazyloadImage: function getArticleLazyloadImage(img, w, h, color, opacity) {
      return {
        src: img || "/image/placeholder/" + w + "/" + h + "/" + color + "/" + opacity,
        error: "/image/placeholder/" + w + "/" + h + "/" + color + "/" + opacity,
        loading: "/image/placeholder/" + w + "/" + h + "/" + color + "/" + opacity
      };
    }
  }
};

/***/ }),

/***/ 917:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(930)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(928),
  /* template */
  __webpack_require__(937),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4b77e75d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 918:
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(152),
    eq = __webpack_require__(105);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),

/***/ 919:
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  return key == '__proto__'
    ? undefined
    : object[key];
}

module.exports = safeGet;


/***/ }),

/***/ 922:
/***/ (function(module, exports) {

/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */
function compact(array) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = compact;


/***/ }),

/***/ 924:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.hasCookies = hasCookies;

var _cookie = __webpack_require__(947);

var _cookie2 = _interopRequireDefault(_cookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var prefix = 'lS_';

var CookieStorage = function () {
  function CookieStorage() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, CookieStorage);

    this.cookieOptions = Object.assign({ path: '/' }, options);
    prefix = options.prefix || prefix;
  }

  _createClass(CookieStorage, [{
    key: 'getItem',
    value: function getItem(key) {
      var cookies = _cookie2.default.parse(document.cookie);
      if (!cookies || !cookies.hasOwnProperty(prefix + key)) {
        return null;
      }
      return cookies[prefix + key];
    }
  }, {
    key: 'setItem',
    value: function setItem(key, value) {
      document.cookie = _cookie2.default.serialize(prefix + key, value, this.cookieOptions);
      return value;
    }
  }, {
    key: 'removeItem',
    value: function removeItem(key) {
      var options = Object.assign({}, this.cookieOptions, { maxAge: -1 });
      document.cookie = _cookie2.default.serialize(prefix + key, '', options);
      return null;
    }
  }, {
    key: 'clear',
    value: function clear() {
      var cookies = _cookie2.default.parse(document.cookie);
      for (var key in cookies) {
        if (key.indexOf(prefix) === 0) {
          this.removeItem(key.substr(prefix.length));
        }
      }

      return null;
    }
  }]);

  return CookieStorage;
}();

exports.default = CookieStorage;
function hasCookies() {
  var storage = new CookieStorage();

  try {
    var TEST_KEY = '__test';
    storage.setItem(TEST_KEY, '1');
    var value = storage.getItem(TEST_KEY);
    storage.removeItem(TEST_KEY);

    return value === '1';
  } catch (e) {
    return false;
  }
}

/***/ }),

/***/ 925:
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),

/***/ 926:
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(933),
    createAssigner = __webpack_require__(226);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),

/***/ 928:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _merge = __webpack_require__(926);

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    lazyload: {
      type: Boolean,
      default: true
    },
    progressiveImage: {
      type: Object,
      required: true
    },
    alt: {
      type: String
    },
    width: {
      type: [String, Number]
    },
    height: {
      type: [String, Number]
    },
    mode: {
      type: String,
      default: 'image'
    },
    customStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      imageLoaded: false,
      imageSrc: null,
      backgroundImageStyle: {}
    };
  },

  computed: {
    blurBackgroundImageStyle: function blurBackgroundImageStyle() {
      return (0, _merge2.default)({
        backgroundImage: 'url(\'' + (0, _get2.default)(this, 'progressiveImage.loading', '') + '\')'
      }, this.customStyle);
    }
  },
  methods: {
    handler: function handler() {
      var _this = this;

      var imageSrc = (0, _get2.default)(this, 'progressiveImage.src');
      if (typeof window !== 'undefined' && imageSrc) {
        var image = new window.Image();
        this.backgroundImageStyle = (0, _merge2.default)({}, this.customStyle);
        if (this.mode === 'background') {
          image.onload = function () {
            _this.backgroundImageStyle = (0, _merge2.default)({
              backgroundImage: 'url(\'' + imageSrc + '\')'
            }, _this.backgroundImageStyle);
            _this.imageLoaded = true;
          };
          image.onerror = function () {
            _this.backgroundImageStyle = (0, _merge2.default)({
              backgroundImage: 'url(\'' + (0, _get2.default)(_this, 'progressiveImage.error', '') + '\')'
            }, _this.backgroundImageStyle);
          };
        } else {
          image.onload = function () {
            _this.imageSrc = imageSrc;
            _this.imageLoaded = true;
          };
          image.onerror = function () {
            _this.imageSrc = (0, _get2.default)(_this, 'progressiveImage.error', '');
          };
        }
        image.src = imageSrc;
      }
    }
  },
  watch: {
    progressiveImage: function progressiveImage() {
      if ((0, _get2.default)(this, 'progressiveImage.src')) {
        this.handler();
      }
    }
  }
};

/***/ }),

/***/ 929:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".mode-background .lazy-wrapper[data-v-4b77e75d]{position:absolute;left:0;top:0;width:100%;height:100%}.mode-background .blur-image[data-v-4b77e75d],.mode-background .image[data-v-4b77e75d]{position:absolute;left:0;top:0;width:100%;height:100%;border:none;border-radius:0;background-position:50%;background-repeat:no-repeat;background-color:transparent;margin-left:auto;margin-right:auto;background-size:cover}img[data-v-4b77e75d]{position:absolute;width:100%;height:auto;left:0;top:0}.holder[data-v-4b77e75d]{position:relative;z-index:0}.lazy-wrapper[data-v-4b77e75d]{position:relative;z-index:2}.blur-image[data-v-4b77e75d]{opacity:1;-webkit-transition:opacity 4s;-o-transition:opacity 4s;transition:opacity 4s}.blur-image.fade-out[data-v-4b77e75d]{opacity:0}.image[data-v-4b77e75d]{opacity:0;-webkit-transition:opacity 2s;-o-transition:opacity 2s;transition:opacity 2s}.image.loaded[data-v-4b77e75d]{opacity:1}.progressive-image[data-v-4b77e75d]{position:relative;margin:0}.blur-holder[data-v-4b77e75d]{z-index:1;position:absolute;left:0;top:0}", "", {"version":3,"sources":["/app/components/widgets/ProgressiveImage.vue"],"names":[],"mappings":"AAgCA,gDACE,kBAAmB,AACnB,OAAQ,AACR,MAAO,AACP,WAAY,AACZ,WAAa,CACd,AACD,uFAEE,kBAAmB,AACnB,OAAQ,AACR,MAAO,AACP,WAAY,AACZ,YAAa,AACb,YAAa,AACb,gBAAiB,AACjB,wBAA4B,AAC5B,4BAA6B,AAC7B,6BAA8B,AAC9B,iBAAkB,AAClB,kBAAmB,AACnB,qBAAuB,CACxB,AACD,qBACE,kBAAmB,AACnB,WAAY,AACZ,YAAa,AACb,OAAQ,AACR,KAAO,CACR,AACD,yBACE,kBAAmB,AACnB,SAAW,CACZ,AACD,+BACE,kBAAmB,AACnB,SAAW,CACZ,AACD,6BACE,UAAW,AACX,8BAA+B,AAC/B,yBAA0B,AAC1B,qBAAuB,CACxB,AACD,sCACI,SAAW,CACd,AACD,wBACE,UAAW,AACX,8BAA+B,AAC/B,yBAA0B,AAC1B,qBAAuB,CACxB,AACD,+BACI,SAAW,CACd,AACD,oCACE,kBAAmB,AACnB,QAAU,CACX,AACD,8BACE,UAAW,AACX,kBAAmB,AACnB,OAAQ,AACR,KAAO,CACR","file":"ProgressiveImage.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.mode-background .lazy-wrapper[data-v-4b77e75d] {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n}\n.mode-background .image[data-v-4b77e75d],\n.mode-background .blur-image[data-v-4b77e75d] {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  border: none;\n  border-radius: 0;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-color: transparent;\n  margin-left: auto;\n  margin-right: auto;\n  background-size: cover;\n}\nimg[data-v-4b77e75d] {\n  position: absolute;\n  width: 100%;\n  height: auto;\n  left: 0;\n  top: 0;\n}\n.holder[data-v-4b77e75d] {\n  position: relative;\n  z-index: 0;\n}\n.lazy-wrapper[data-v-4b77e75d] {\n  position: relative;\n  z-index: 2;\n}\n.blur-image[data-v-4b77e75d] {\n  opacity: 1;\n  -webkit-transition: opacity 4s;\n  -o-transition: opacity 4s;\n  transition: opacity 4s;\n}\n.blur-image.fade-out[data-v-4b77e75d] {\n    opacity: 0;\n}\n.image[data-v-4b77e75d] {\n  opacity: 0;\n  -webkit-transition: opacity 2s;\n  -o-transition: opacity 2s;\n  transition: opacity 2s;\n}\n.image.loaded[data-v-4b77e75d] {\n    opacity: 1;\n}\n.progressive-image[data-v-4b77e75d] {\n  position: relative;\n  margin: 0;\n}\n.blur-holder[data-v-4b77e75d] {\n  z-index: 1;\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 930:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(929);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("731e180e", content, true, {});

/***/ }),

/***/ 932:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MemoryStorage = exports.CookieStorage = exports.isSupported = exports.storage = undefined;

var _isSupported = __webpack_require__(950);

var _isSupported2 = _interopRequireDefault(_isSupported);

var _CookieStorage = __webpack_require__(924);

var _CookieStorage2 = _interopRequireDefault(_CookieStorage);

var _MemoryStorage = __webpack_require__(949);

var _MemoryStorage2 = _interopRequireDefault(_MemoryStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var storage = null;

if ((0, _isSupported2.default)('localStorage')) {
  // use localStorage
  exports.storage = storage = window.localStorage;
} else if ((0, _isSupported2.default)('sessionStorage')) {
  // use sessionStorage
  exports.storage = storage = window.sessionStorage;
} else if ((0, _isSupported2.default)('cookieStorage')) {
  // use cookies
  exports.storage = storage = new _CookieStorage2.default();
} else {
  // use memory
  exports.storage = storage = new _MemoryStorage2.default();
}

exports.default = storage;
exports.storage = storage;
exports.isSupported = _isSupported2.default;
exports.CookieStorage = _CookieStorage2.default;
exports.MemoryStorage = _MemoryStorage2.default;

/***/ }),

/***/ 933:
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(151),
    assignMergeValue = __webpack_require__(918),
    baseFor = __webpack_require__(341),
    baseMergeDeep = __webpack_require__(934),
    isObject = __webpack_require__(31),
    keysIn = __webpack_require__(148),
    safeGet = __webpack_require__(919);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    if (isObject(srcValue)) {
      stack || (stack = new Stack);
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),

/***/ 934:
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(918),
    cloneBuffer = __webpack_require__(342),
    cloneTypedArray = __webpack_require__(343),
    copyArray = __webpack_require__(337),
    initCloneObject = __webpack_require__(344),
    isArguments = __webpack_require__(106),
    isArray = __webpack_require__(10),
    isArrayLikeObject = __webpack_require__(149),
    isBuffer = __webpack_require__(107),
    isFunction = __webpack_require__(84),
    isObject = __webpack_require__(31),
    isPlainObject = __webpack_require__(935),
    isTypedArray = __webpack_require__(153),
    safeGet = __webpack_require__(919),
    toPlainObject = __webpack_require__(936);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),

/***/ 935:
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(52),
    getPrototype = __webpack_require__(227),
    isObjectLike = __webpack_require__(32);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ 936:
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(75),
    keysIn = __webpack_require__(148);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),

/***/ 937:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "wrapper",
    staticClass: "progressive-image",
    class: [("mode-" + _vm.mode)],
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }, [_c('lazy-component', {
    ref: "lazyWrapper",
    staticClass: "lazy-wrapper",
    on: {
      "show": _vm.handler
    }
  }, [(_vm.mode === 'background') ? [_c('div', {
    staticClass: "image",
    class: {
      loaded: _vm.imageLoaded
    },
    style: (_vm.backgroundImageStyle)
  }), _c('div', {
    staticClass: "blur-image",
    class: {
      'fade-out': _vm.imageLoaded
    },
    style: (_vm.blurBackgroundImageStyle)
  })] : [(_vm.imageSrc) ? _c('img', {
    staticClass: "image",
    class: {
      loaded: _vm.imageLoaded
    },
    style: (_vm.customStyle),
    attrs: {
      "alt": _vm.progressiveImage.alt,
      "src": _vm.imageSrc
    }
  }) : _vm._e(), _c('img', {
    staticClass: "blur-image",
    class: {
      'fade-out': _vm.imageLoaded
    },
    style: (_vm.customStyle),
    attrs: {
      "src": _vm.progressiveImage.loading,
      "alt": _vm.progressiveImage.alt
    }
  })]], 2), (_vm.mode === 'background') ? [_c('div', {
    staticClass: "blur-image blur-holder",
    class: {
      'fade-out': _vm.imageLoaded
    },
    style: (_vm.blurBackgroundImageStyle)
  })] : [_c('img', {
    staticClass: "blur-holder blur-image",
    class: {
      'fade-out': _vm.imageLoaded
    },
    attrs: {
      "src": _vm.progressiveImage.loading,
      "width": _vm.width,
      "height": _vm.height
    }
  })], _c('img', {
    staticClass: "holder",
    attrs: {
      "src": _vm.progressiveImage.holder,
      "width": _vm.width,
      "height": _vm.height
    }
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 939:
/***/ (function(module, exports, __webpack_require__) {

// sourced from:
// http://www.leanbackplayer.com/test/h5mt.html
// https://github.com/broofa/node-mime/blob/master/types.json
var mimeTypes = __webpack_require__(969)

var mimeLookup = {}
Object.keys(mimeTypes).forEach(function (key) {
  var extensions = mimeTypes[key]
  extensions.forEach(function (ext) {
    mimeLookup[ext] = key
  })
})

module.exports = function lookup (ext) {
  if (!ext) throw new TypeError('must specify extension string')
  if (ext.indexOf('.') === 0) {
    ext = ext.substring(1)
  }
  return mimeLookup[ext.toLowerCase()]
}


/***/ }),

/***/ 940:
/***/ (function(module, exports) {

module.exports = isFunction

var toString = Object.prototype.toString

function isFunction (fn) {
  var string = toString.call(fn)
  return string === '[object Function]' ||
    (typeof fn === 'function' && string !== '[object RegExp]') ||
    (typeof window !== 'undefined' &&
     // IE8 and below
     (fn === window.setTimeout ||
      fn === window.alert ||
      fn === window.confirm ||
      fn === window.prompt))
};


/***/ }),

/***/ 941:
/***/ (function(module, exports) {

module.exports = createAudioContext
function createAudioContext () {
  var AudioCtor = window.AudioContext || window.webkitAudioContext
  return new AudioCtor()
}


/***/ }),

/***/ 942:
/***/ (function(module, exports, __webpack_require__) {

var lookup = __webpack_require__(939)
var audio

module.exports = isSrcPlayable
function isSrcPlayable (src) {
  if (!src) throw new TypeError('src cannot be empty')
  var type
  if (typeof src.getAttribute === 'function') {
    // <source> element
    type = src.getAttribute('type')
  } else if (typeof src === 'string') {
    // 'foo.mp3' string
    var ext = extension(src)
    if (ext) type = lookup(ext)
  } else {
    // { src: 'foo.mp3', type: 'audio/mpeg; codecs..'}
    type = src.type
  }

  // We have an unknown file extension or
  // a <source> tag without an explicit type,
  // just let the browser handle it!
  if (!type) return true

  // handle "no" edge case with super legacy browsers...
  // https://groups.google.com/forum/#!topic/google-web-toolkit-contributors/a8Uy0bXq1Ho
  if (!audio) audio = new window.Audio()
  var canplay = audio.canPlayType(type).replace(/no/, '')
  return Boolean(canplay)
}

module.exports.createError = createError
function createError (sources) {
  // All sources are unplayable
  var err = new Error('This browser does not support any of the following sources:\n    ' +
      sources.join(', ') + '\n' +
      'Try using an array of OGG, MP3 and WAV.')
  err.type = 'AUDIO_FORMAT'
  return err
}

function extension (data) {
  var extIdx = data.lastIndexOf('.')
  if (extIdx <= 0 || extIdx === data.length - 1) {
    return undefined
  }
  return data.substring(extIdx + 1)
}


/***/ }),

/***/ 943:
/***/ (function(module, exports) {

module.exports = function (audioContext) {
  if (audioContext.state === 'suspended' &&
      typeof audioContext.resume === 'function') {
    audioContext.resume()
  }
}


/***/ }),

/***/ 947:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;
var pairSplitRegExp = /; */;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(pairSplitRegExp);
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var eq_idx = pair.indexOf('=');

    // skip things that don't look like key=value
    if (eq_idx < 0) {
      continue;
    }

    var key = pair.substr(0, eq_idx).trim()
    var val = pair.substr(++eq_idx, pair.length).trim();

    // quoted values
    if ('"' == val[0]) {
      val = val.slice(1, -1);
    }

    // only assign once
    if (undefined == obj[key]) {
      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;
    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ 949:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MemoryStorage = function () {
  function MemoryStorage() {
    _classCallCheck(this, MemoryStorage);

    this._data = {};
  }

  _createClass(MemoryStorage, [{
    key: "getItem",
    value: function getItem(key) {
      return this._data.hasOwnProperty(key) ? this._data[key] : null;
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      return this._data[key] = String(value);
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      return delete this._data[key];
    }
  }, {
    key: "clear",
    value: function clear() {
      return this._data = {};
    }
  }]);

  return MemoryStorage;
}();

exports.default = MemoryStorage;

/***/ }),

/***/ 950:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isSupported;

var _CookieStorage = __webpack_require__(924);

var TEST_KEY = '__test';

function hasStorage(name) {
  try {
    var storage = window[name];
    storage.setItem(TEST_KEY, '1');
    storage.removeItem(TEST_KEY);
    return true;
  } catch (e) {
    return false;
  }
}

function isSupported() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'localStorage';

  var storage = String(name).replace(/storage$/i, '').toLowerCase();

  if (storage === 'local') {
    return hasStorage('localStorage');
  }

  if (storage === 'session') {
    return hasStorage('sessionStorage');
  }

  if (storage === 'cookie') {
    return (0, _CookieStorage.hasCookies)();
  }

  if (storage === 'memory') {
    return true;
  }

  throw new Error('Storage method `' + name + '` is not available.\n    Please use one of the following: localStorage, sessionStorage, cookieStorage, memoryStorage.');
}

/***/ }),

/***/ 951:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1088)
  __webpack_require__(1089)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1060),
  /* template */
  __webpack_require__(1105),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-dc463cd0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 953:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(14);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(12);

var _webAudioPlayer = __webpack_require__(989);

var _webAudioPlayer2 = _interopRequireDefault(_webAudioPlayer);

var _has = __webpack_require__(102);

var _has2 = _interopRequireDefault(_has);

var _get = __webpack_require__(5);

var _get2 = _interopRequireDefault(_get);

var _includes = __webpack_require__(73);

var _includes2 = _interopRequireDefault(_includes);

var _union = __webpack_require__(230);

var _union2 = _interopRequireDefault(_union);

var _isUndefined = __webpack_require__(85);

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _split = __webpack_require__(345);

var _split2 = _interopRequireDefault(_split);

var _compact = __webpack_require__(922);

var _compact2 = _interopRequireDefault(_compact);

var _toString = __webpack_require__(25);

var _toString2 = _interopRequireDefault(_toString);

var _map = __webpack_require__(57);

var _map2 = _interopRequireDefault(_map);

var _axios = __webpack_require__(229);

var _axios2 = _interopRequireDefault(_axios);

var _gtmManager = __webpack_require__(223);

var _gtmManager2 = _interopRequireDefault(_gtmManager);

var _localStorageFallback = __webpack_require__(932);

var _localStorageFallback2 = _interopRequireDefault(_localStorageFallback);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = __webpack_require__(349);

exports.default = {
  data: function data() {
    return {
      defaultTermId: 325163,
      defaultSectionName: 'Best of abacus'
    };
  },
  mounted: function mounted() {
    var _this = this;

    try {
      if (!(0, _has2.default)(this, '$root.audio1')) {
        this.$root.audio1 = false;
        var audio1 = (0, _webAudioPlayer2.default)('/static/sounds/littlerobotsoundfactory-03.mp3', {
          buffer: true
        });
        audio1.on('load', function () {
          _this.$root.audio1 = audio1;
          if (!(0, _has2.default)(_this, '$root.audio2')) {
            _this.$root.audio2 = false;
            var audio2 = (0, _webAudioPlayer2.default)('/static/sounds/littlerobotsoundfactory-01.mp3', {
              buffer: true,
              context: _this.$root.audio1.context
            });
            audio2.on('load', function () {
              _this.$root.audio2 = audio2;
            });
          }
        });
      }
    } catch (e) {
      console.log(e);
      console.log('Browser do not support web audio player.');
    }
  },

  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)(['toggleNewsletter']), {
    validateEmail: function validateEmail(email) {
      var checking = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return checking.test(email);
    },
    play1: function play1() {
      if (this.$root.audio1) {
        try {
          this.$root.audio1.play();
          this.$root.audio1.node.connect(this.$root.audio1.context.destination);
        } catch (e) {
          console.log(e);
          console.log('Browser do not support web audio player.');
        }
      }
    },
    play2: function play2() {
      if (this.$root.audio2) {
        try {
          this.$root.audio2.play();
          this.$root.audio2.node.connect(this.$root.audio1.context.destination);
        } catch (e) {
          console.log(e);
          console.log('Browser do not support web audio player.');
        }
      }
    },
    subscribeNewsletter: function subscribeNewsletter(email, section, gtmNewsletterCategory) {
      var _this2 = this;

      var endpoint = (0, _get2.default)(this, '$store.state.settings.NEWSLETTER_API_ENDPOINT');
      var termId = (0, _get2.default)(section, 'tid', this.defaultTermId);
      var appId = (0, _get2.default)(config, 'APP_TID');
      var entityType = 'taxonomy_term';
      var sectionName = (0, _get2.default)(section, 'name', this.defaultSectionName);

      if (email && endpoint && termId && appId) {
        _axios2.default.post('' + endpoint, {
          email: email,
          id: termId,
          entity_type: entityType,
          app_id: appId
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          if (response.data.status === 'success') {
            if (gtmNewsletterCategory) {
              _this2.updateStorageList(termId);

              _gtmManager2.default.pushTracker({
                category: gtmNewsletterCategory,
                action: 'Newsletter Sign Up',
                label: sectionName
              });
            }
            return true;
          }
          return false;
        });
      }
      return false;
    },
    checkSubscribedToList: function checkSubscribedToList(section) {
      var originalList = this.getOriginalStorageList();
      var termId = (0, _get2.default)(section, 'tid', this.defaultTermId);

      if ((0, _includes2.default)(originalList, termId)) {
        this.toggleNewsletter(false);
        return;
      }
      this.toggleNewsletter(true);
    },
    getOriginalStorageList: function getOriginalStorageList() {
      var getStorageData = _localStorageFallback2.default.getItem('nwsltrs_subscribed');
      return !(0, _isUndefined2.default)(getStorageData) ? (0, _compact2.default)((0, _map2.default)((0, _split2.default)(getStorageData, ','), Number)) : [];
    },
    updateStorageList: function updateStorageList(appendTermId) {
      var originalList = this.getOriginalStorageList();
      var newList = (0, _union2.default)(originalList, [appendTermId]);
      _localStorageFallback2.default.setItem('nwsltrs_subscribed', (0, _toString2.default)(newList));
    }
  })
};

/***/ }),

/***/ 958:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ 969:
/***/ (function(module, exports) {

module.exports = {"audio/midi":["mid","midi","kar","rmi"],"audio/mp4":["mp4a","m4a"],"audio/mpeg":["mpga","mp2","mp2a","mp3","m2a","m3a"],"audio/ogg":["oga","ogg","spx"],"audio/webm":["weba"],"audio/x-matroska":["mka"],"audio/x-mpegurl":["m3u"],"audio/wav":["wav"],"video/3gpp":["3gp"],"video/3gpp2":["3g2"],"video/mp4":["mp4","mp4v","mpg4"],"video/mpeg":["mpeg","mpg","mpe","m1v","m2v"],"video/ogg":["ogv"],"video/quicktime":["qt","mov"],"video/webm":["webm"],"video/x-f4v":["f4v"],"video/x-fli":["fli"],"video/x-flv":["flv"],"video/x-m4v":["m4v"],"video/x-matroska":["mkv","mk3d","mks"]}

/***/ }),

/***/ 973:
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(940)

module.exports = forEach

var toString = Object.prototype.toString
var hasOwnProperty = Object.prototype.hasOwnProperty

function forEach(list, iterator, context) {
    if (!isFunction(iterator)) {
        throw new TypeError('iterator must be a function')
    }

    if (arguments.length < 3) {
        context = this
    }
    
    if (toString.call(list) === '[object Array]')
        forEachArray(list, iterator, context)
    else if (typeof list === 'string')
        forEachString(list, iterator, context)
    else
        forEachObject(list, iterator, context)
}

function forEachArray(array, iterator, context) {
    for (var i = 0, len = array.length; i < len; i++) {
        if (hasOwnProperty.call(array, i)) {
            iterator.call(context, array[i], i, array)
        }
    }
}

function forEachString(string, iterator, context) {
    for (var i = 0, len = string.length; i < len; i++) {
        // no such thing as a sparse string.
        iterator.call(context, string.charAt(i), i, string)
    }
}

function forEachObject(object, iterator, context) {
    for (var k in object) {
        if (hasOwnProperty.call(object, k)) {
            iterator.call(context, object[k], k, object)
        }
    }
}


/***/ }),

/***/ 974:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var win;

if (typeof window !== "undefined") {
    win = window;
} else if (typeof global !== "undefined") {
    win = global;
} else if (typeof self !== "undefined"){
    win = self;
} else {
    win = {};
}

module.exports = win;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),

/***/ 975:
/***/ (function(module, exports) {

module.exports = isNode

function isNode (val) {
  return (!val || typeof val !== 'object')
    ? false
    : (typeof window === 'object' && typeof window.Node === 'object')
      ? (val instanceof window.Node)
      : (typeof val.nodeType === 'number') &&
        (typeof val.nodeName === 'string')
}


/***/ }),

/***/ 976:
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(352),
    baseEach = __webpack_require__(108),
    baseIteratee = __webpack_require__(74),
    baseReduce = __webpack_require__(1035),
    isArray = __webpack_require__(10);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),

/***/ 977:
/***/ (function(module, exports, __webpack_require__) {

var trim = __webpack_require__(980)
  , forEach = __webpack_require__(973)
  , isArray = function(arg) {
      return Object.prototype.toString.call(arg) === '[object Array]';
    }

module.exports = function (headers) {
  if (!headers)
    return {}

  var result = {}

  forEach(
      trim(headers).split('\n')
    , function (row) {
        var index = row.indexOf(':')
          , key = trim(row.slice(0, index)).toLowerCase()
          , value = trim(row.slice(index + 1))

        if (typeof(result[key]) === 'undefined') {
          result[key] = value
        } else if (isArray(result[key])) {
          result[key].push(value)
        } else {
          result[key] = [ result[key], value ]
        }
      }
  )

  return result
}

/***/ }),

/***/ 978:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports =
  global.performance &&
  global.performance.now ? function now() {
    return performance.now()
  } : Date.now || function now() {
    return +new Date
  }

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),

/***/ 979:
/***/ (function(module, exports, __webpack_require__) {

var isDom = __webpack_require__(975)
var lookup = __webpack_require__(939)

module.exports.video = simpleMediaElement.bind(null, 'video')
module.exports.audio = simpleMediaElement.bind(null, 'audio')

function simpleMediaElement (elementName, sources, opt) {
  opt = opt || {}

  if (!Array.isArray(sources)) {
    sources = [ sources ]
  }

  var media = opt.element || document.createElement(elementName)

  if (opt.loop) media.setAttribute('loop', 'loop')
  if (opt.muted) media.setAttribute('muted', 'muted')
  if (opt.autoplay) media.setAttribute('autoplay', 'autoplay')
  if (opt.controls) media.setAttribute('controls', 'controls')
  if (opt.crossOrigin) media.setAttribute('crossorigin', opt.crossOrigin)
  if (opt.preload) media.setAttribute('preload', opt.preload)
  if (opt.poster) media.setAttribute('poster', opt.poster)
  if (typeof opt.volume !== 'undefined') media.setAttribute('volume', opt.volume)

  sources = sources.filter(Boolean)
  sources.forEach(function (source) {
    media.appendChild(createSourceElement(source))
  })

  return media
}

function createSourceElement (data) {
  if (isDom(data)) return data
  if (typeof data === 'string') {
    data = { src: data }
    if (data.src) {
      var ext = extension(data.src)
      if (ext) data.type = lookup(ext)
    }
  }

  var source = document.createElement('source')
  if (data.src) source.setAttribute('src', data.src)
  if (data.type) source.setAttribute('type', data.type)
  return source
}

function extension (data) {
  var extIdx = data.lastIndexOf('.')
  if (extIdx <= 0 || extIdx === data.length - 1) {
    return null
  }
  return data.substring(extIdx + 1)
}


/***/ }),

/***/ 980:
/***/ (function(module, exports) {


exports = module.exports = trim;

function trim(str){
  return str.replace(/^\s*|\s*$/g, '');
}

exports.left = function(str){
  return str.replace(/^\s*/, '');
};

exports.right = function(str){
  return str.replace(/\s*$/, '');
};


/***/ }),

/***/ 989:
/***/ (function(module, exports, __webpack_require__) {

var buffer = __webpack_require__(990)
var media = __webpack_require__(992)

module.exports = webAudioPlayer
function webAudioPlayer (src, opt) {
  if (!src) throw new TypeError('must specify a src parameter')
  opt = opt || {}
  if (opt.buffer) return buffer(src, opt)
  else return media(src, opt)
}


/***/ }),

/***/ 990:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var canPlaySrc = __webpack_require__(942)
var createAudioContext = __webpack_require__(941)
var xhrAudio = __webpack_require__(993)
var EventEmitter = __webpack_require__(925).EventEmitter
var rightNow = __webpack_require__(978)
var resume = __webpack_require__(943)

module.exports = createBufferSource
function createBufferSource (src, opt) {
  opt = opt || {}
  var emitter = new EventEmitter()
  var audioContext = opt.context || createAudioContext()

  // a pass-through node so user just needs to
  // connect() once
  var bufferNode, buffer, duration
  var node = audioContext.createGain()
  var audioStartTime = null
  var audioPauseTime = null
  var audioCurrentTime = 0
  var playing = false
  var loop = opt.loop

  emitter.play = function () {
    if (playing) return
    playing = true

    if (opt.autoResume !== false) resume(emitter.context)
    disposeBuffer()
    bufferNode = audioContext.createBufferSource()
    bufferNode.connect(emitter.node)
    bufferNode.onended = ended
    if (buffer) {
      // Might be null undefined if we are still loading
      bufferNode.buffer = buffer
    }
    if (loop) {
      bufferNode.loop = true
      if (typeof opt.loopStart === 'number') bufferNode.loopStart = opt.loopStart
      if (typeof opt.loopEnd === 'number') bufferNode.loopEnd = opt.loopEnd
    }

    if (duration && audioCurrentTime > duration) {
      // for when it loops...
      audioCurrentTime = audioCurrentTime % duration
    }
    var nextTime = audioCurrentTime

    bufferNode.start(0, nextTime)
    audioStartTime = rightNow()
  }

  emitter.pause = function () {
    if (!playing) return
    playing = false
    // Don't let the "end" event
    // get triggered on manual pause.
    bufferNode.onended = null
    bufferNode.stop(0)
    audioPauseTime = rightNow()
    audioCurrentTime += (audioPauseTime - audioStartTime) / 1000
  }

  emitter.stop = function () {
    emitter.pause()
    ended()
  }

  emitter.dispose = function () {
    disposeBuffer()
    buffer = null
  }

  emitter.node = node
  emitter.context = audioContext

  Object.defineProperties(emitter, {
    duration: {
      enumerable: true, configurable: true,
      get: function () {
        return duration
      }
    },
    playing: {
      enumerable: true, configurable: true,
      get: function () {
        return playing
      }
    },
    buffer: {
      enumerable: true, configurable: true,
      get: function () {
        return buffer
      }
    },
    volume: {
      enumerable: true, configurable: true,
      get: function () {
        return node.gain.value
      },
      set: function (n) {
        node.gain.value = n
      }
    }
  })

  // set initial volume
  if (typeof opt.volume === 'number') {
    emitter.volume = opt.volume
  }

  // filter down to a list of playable sources
  var sources = Array.isArray(src) ? src : [ src ]
  sources = sources.filter(Boolean)
  var playable = sources.some(canPlaySrc)
  if (playable) {
    var source = sources.filter(canPlaySrc)[0]
    // Support the same source types as in
    // MediaElement mode...
    if (typeof source.getAttribute === 'function') {
      source = source.getAttribute('src')
    } else if (typeof source.src === 'string') {
      source = source.src
    }
    // We have at least one playable source.
    // For now just play the first,
    // ideally this module could attempt each one.
    startLoad(source)
  } else {
    // no sources can be played...
    process.nextTick(function () {
      emitter.emit('error', canPlaySrc.createError(sources))
    })
  }
  return emitter

  function startLoad (src) {
    xhrAudio(audioContext, src, function audioDecoded (err, decoded) {
      if (err) return emitter.emit('error', err)
      buffer = decoded // store for later use
      if (bufferNode) {
        // if play() was called early
        bufferNode.buffer = buffer
      }
      duration = buffer.duration
      node.buffer = buffer
      emitter.emit('load')
    }, function audioProgress (amount, total) {
      emitter.emit('progress', amount, total)
    }, function audioDecoding () {
      emitter.emit('decoding')
    })
  }

  function ended () {
    emitter.emit('end')
    playing = false
    audioCurrentTime = 0
  }

  function disposeBuffer () {
    if (bufferNode) bufferNode.disconnect()
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(104)))

/***/ }),

/***/ 991:
/***/ (function(module, exports) {

module.exports = addOnce
function addOnce (element, event, fn) {
  function tmp (ev) {
    element.removeEventListener(event, tmp, false)
    fn(ev, element)
  }
  element.addEventListener(event, tmp, false)
}

/***/ }),

/***/ 992:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var EventEmitter = __webpack_require__(925).EventEmitter
var createAudio = __webpack_require__(979).audio
var assign = __webpack_require__(958)

var resume = __webpack_require__(943)
var createAudioContext = __webpack_require__(941)
var canPlaySrc = __webpack_require__(942)
var addOnce = __webpack_require__(991)

module.exports = createMediaSource
function createMediaSource (src, opt) {
  opt = assign({}, opt)
  var emitter = new EventEmitter()

  // Default to Audio instead of HTMLAudioElement
  // There is not much difference except in the following:
  //    x instanceof Audio
  //    x instanceof HTMLAudioElement
  // And in my experience Audio has better support on various
  // platforms like CocoonJS.
  // Please open an issue if there is a concern with this.
  if (!opt.element) opt.element = new window.Audio()

  var desiredVolume = opt.volume
  delete opt.volume // make sure <audio> tag receives full volume
  var audio = createAudio(src, opt)
  var audioContext = opt.context || createAudioContext()
  var node = audioContext.createGain()
  var mediaNode = audioContext.createMediaElementSource(audio)
  mediaNode.connect(node)

  audio.addEventListener('ended', function () {
    emitter.emit('end')
  })

  var loopStart = opt.loopStart
  var loopEnd = opt.loopEnd
  var hasLoopStart = typeof loopStart === 'number' && isFinite(loopStart)
  var hasLoopEnd = typeof loopEnd === 'number' && isFinite(loopEnd)
  var isLoopReady = false
  if (hasLoopStart || hasLoopEnd) {
    window.requestAnimationFrame(function update () {
      // audio hasn't been loaded yet...
      if (typeof audio.duration !== 'number') return
      var currentTime = audio.currentTime

      // where to end the buffer
      var endTime = hasLoopEnd ? Math.min(audio.duration, loopEnd) : audio.duration

      if (currentTime > (loopStart || 0)) {
        isLoopReady = true
      }

      // jump ahead to loop start point
      if (hasLoopStart && isLoopReady && currentTime < loopStart) {
        audio.currentTime = loopStart
      }

      // if we've hit the end of the buffer
      if (currentTime >= endTime) {
        // if there is no loop end point, let native looping take over
        // if we have a loop end point, jump back to start point or zero
        if (hasLoopEnd) {
          audio.currentTime = hasLoopStart ? loopStart : 0
        }
      }
      window.requestAnimationFrame(update)
    });
  }

  emitter.element = audio
  emitter.context = audioContext
  emitter.node = node
  emitter.pause = audio.pause.bind(audio)
  emitter.play = function () {
    if (opt.autoResume !== false) resume(emitter.context)
    return audio.play()
  }

  // This exists currently for parity with Buffer source
  // Open to suggestions for what this should dispose...
  emitter.dispose = function () {}

  emitter.stop = function () {
    var wasPlaying = emitter.playing
    audio.pause()
    audio.currentTime = 0
    isLoopReady = false
    if (wasPlaying) {
      emitter.emit('end')
    }
  }

  Object.defineProperties(emitter, {
    duration: {
      enumerable: true, configurable: true,
      get: function () {
        return audio.duration
      }
    },
    currentTime: {
      enumerable: true, configurable: true,
      get: function () {
        return audio.currentTime
      }
    },
    playing: {
      enumerable: true, configurable: true,
      get: function () {
        return !audio.paused
      }
    },
    volume: {
      enumerable: true, configurable: true,
      get: function () {
        return node.gain.value
      },
      set: function (n) {
        node.gain.value = n
      }
    }
  })

  // Set initial volume
  if (typeof desiredVolume === 'number') {
    emitter.volume = desiredVolume
  }

  // Check if all sources are unplayable,
  // if so we emit an error since the browser
  // might not.
  var sources = Array.isArray(src) ? src : [ src ]
  sources = sources.filter(Boolean)
  var playable = sources.some(canPlaySrc)
  if (playable) {
    // At least one source is probably/maybe playable
    startLoad()
  } else {
    // emit error on next tick so user can catch it
    process.nextTick(function () {
      emitter.emit('error', canPlaySrc.createError(sources))
    })
  }

  return emitter

  function startLoad () {
    // The file errors (like decoding / 404s) appear on <source>
    var srcElements = Array.prototype.slice.call(audio.children)
    var remainingSrcErrors = srcElements.length
    var hasErrored = false
    var sourceError = function (err, el) {
      if (hasErrored) return
      remainingSrcErrors--
      console.warn('Error loading source: ' + el.getAttribute('src'))
      if (remainingSrcErrors <= 0) {
        hasErrored = true
        srcElements.forEach(function (el) {
          el.removeEventListener('error', sourceError, false)
        })
        emitter.emit('error', new Error('Could not play any of the supplied sources'))
      }
    }

    var done = function () {
      emitter.emit('load')
    }

    if (audio.readyState >= audio.HAVE_ENOUGH_DATA) {
      process.nextTick(done)
    } else {
      addOnce(audio, 'canplay', done)
      addOnce(audio, 'error', function (ev) {
        emitter.emit(new Error('Unknown error while loading <audio>'))
      })
      srcElements.forEach(function (el) {
        addOnce(el, 'error', sourceError)
      })
    }

    // On most browsers the loading begins
    // immediately. However, on iOS 9.2 Safari,
    // you need to call load() for events
    // to be triggered.
    audio.load()
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(104)))

/***/ }),

/***/ 993:
/***/ (function(module, exports, __webpack_require__) {

var xhr = __webpack_require__(995)
var xhrProgress = __webpack_require__(994)

module.exports = xhrAudio
function xhrAudio (audioContext, src, cb, progress, decoding) {
  var xhrObject = xhr({
    uri: src,
    responseType: 'arraybuffer'
  }, function (err, resp, arrayBuf) {
    if (!/^2/.test(resp.statusCode)) {
      err = new Error('status code ' + resp.statusCode + ' requesting ' + src)
    }
    if (err) return cb(err)
    decode(arrayBuf)
  })

  xhrProgress(xhrObject)
    .on('data', function (amount, total) {
      progress(amount, total)
    })

  function decode (arrayBuf) {
    decoding()
    audioContext.decodeAudioData(arrayBuf, function (decoded) {
      cb(null, decoded)
    }, function () {
      var err = new Error('Error decoding audio data')
      err.type = 'DECODE_AUDIO_DATA'
      cb(err)
    })
  }
}


/***/ }),

/***/ 994:
/***/ (function(module, exports, __webpack_require__) {

var EventEmitter = __webpack_require__(925).EventEmitter

module.exports = progress

function progress(xhr) {
  var emitter = new EventEmitter
  var finished = false

  if (xhr.attachEvent) {
    xhr.attachEvent('onreadystatechange', done)
    return emitter
  }

  xhr.addEventListener('load', done, false)
  xhr.addEventListener('progress', progress, false)
  function progress(event) {
    var value = event.lengthComputable
      ? event.loaded / event.total
      : 0

    if (!finished) emitter.emit('data'
      , value
      , event.total || null
    )

    finished = value === 1
  }

  function done(event) {
    if (event.type !== 'load' && !/^(ready|complete)$/g.test(
      (event.currentTarget || event.srcElement).readyState
    )) return

    if (finished) return
    if (xhr.removeEventListener) {
      xhr.removeEventListener('load', done, false)
      xhr.removeEventListener('progress', progress, false)
    } else
    if (xhr.detatchEvent) {
      xhr.detatchEvent('onreadystatechange', done)
    }

    emitter.emit('data', 1, event.total || null)
    emitter.emit('done')
    finished = true
  }

  return emitter
}


/***/ }),

/***/ 995:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var window = __webpack_require__(974)
var isFunction = __webpack_require__(940)
var parseHeaders = __webpack_require__(977)
var xtend = __webpack_require__(996)

module.exports = createXHR
createXHR.XMLHttpRequest = window.XMLHttpRequest || noop
createXHR.XDomainRequest = "withCredentials" in (new createXHR.XMLHttpRequest()) ? createXHR.XMLHttpRequest : window.XDomainRequest

forEachArray(["get", "put", "post", "patch", "head", "delete"], function(method) {
    createXHR[method === "delete" ? "del" : method] = function(uri, options, callback) {
        options = initParams(uri, options, callback)
        options.method = method.toUpperCase()
        return _createXHR(options)
    }
})

function forEachArray(array, iterator) {
    for (var i = 0; i < array.length; i++) {
        iterator(array[i])
    }
}

function isEmpty(obj){
    for(var i in obj){
        if(obj.hasOwnProperty(i)) return false
    }
    return true
}

function initParams(uri, options, callback) {
    var params = uri

    if (isFunction(options)) {
        callback = options
        if (typeof uri === "string") {
            params = {uri:uri}
        }
    } else {
        params = xtend(options, {uri: uri})
    }

    params.callback = callback
    return params
}

function createXHR(uri, options, callback) {
    options = initParams(uri, options, callback)
    return _createXHR(options)
}

function _createXHR(options) {
    if(typeof options.callback === "undefined"){
        throw new Error("callback argument missing")
    }

    var called = false
    var callback = function cbOnce(err, response, body){
        if(!called){
            called = true
            options.callback(err, response, body)
        }
    }

    function readystatechange() {
        if (xhr.readyState === 4) {
            setTimeout(loadFunc, 0)
        }
    }

    function getBody() {
        // Chrome with requestType=blob throws errors arround when even testing access to responseText
        var body = undefined

        if (xhr.response) {
            body = xhr.response
        } else {
            body = xhr.responseText || getXml(xhr)
        }

        if (isJson) {
            try {
                body = JSON.parse(body)
            } catch (e) {}
        }

        return body
    }

    function errorFunc(evt) {
        clearTimeout(timeoutTimer)
        if(!(evt instanceof Error)){
            evt = new Error("" + (evt || "Unknown XMLHttpRequest Error") )
        }
        evt.statusCode = 0
        return callback(evt, failureResponse)
    }

    // will load the data & process the response in a special response object
    function loadFunc() {
        if (aborted) return
        var status
        clearTimeout(timeoutTimer)
        if(options.useXDR && xhr.status===undefined) {
            //IE8 CORS GET successful response doesn't have a status field, but body is fine
            status = 200
        } else {
            status = (xhr.status === 1223 ? 204 : xhr.status)
        }
        var response = failureResponse
        var err = null

        if (status !== 0){
            response = {
                body: getBody(),
                statusCode: status,
                method: method,
                headers: {},
                url: uri,
                rawRequest: xhr
            }
            if(xhr.getAllResponseHeaders){ //remember xhr can in fact be XDR for CORS in IE
                response.headers = parseHeaders(xhr.getAllResponseHeaders())
            }
        } else {
            err = new Error("Internal XMLHttpRequest Error")
        }
        return callback(err, response, response.body)
    }

    var xhr = options.xhr || null

    if (!xhr) {
        if (options.cors || options.useXDR) {
            xhr = new createXHR.XDomainRequest()
        }else{
            xhr = new createXHR.XMLHttpRequest()
        }
    }

    var key
    var aborted
    var uri = xhr.url = options.uri || options.url
    var method = xhr.method = options.method || "GET"
    var body = options.body || options.data
    var headers = xhr.headers = options.headers || {}
    var sync = !!options.sync
    var isJson = false
    var timeoutTimer
    var failureResponse = {
        body: undefined,
        headers: {},
        statusCode: 0,
        method: method,
        url: uri,
        rawRequest: xhr
    }

    if ("json" in options && options.json !== false) {
        isJson = true
        headers["accept"] || headers["Accept"] || (headers["Accept"] = "application/json") //Don't override existing accept header declared by user
        if (method !== "GET" && method !== "HEAD") {
            headers["content-type"] || headers["Content-Type"] || (headers["Content-Type"] = "application/json") //Don't override existing accept header declared by user
            body = JSON.stringify(options.json === true ? body : options.json)
        }
    }

    xhr.onreadystatechange = readystatechange
    xhr.onload = loadFunc
    xhr.onerror = errorFunc
    // IE9 must have onprogress be set to a unique function.
    xhr.onprogress = function () {
        // IE must die
    }
    xhr.onabort = function(){
        aborted = true;
    }
    xhr.ontimeout = errorFunc
    xhr.open(method, uri, !sync, options.username, options.password)
    //has to be after open
    if(!sync) {
        xhr.withCredentials = !!options.withCredentials
    }
    // Cannot set timeout with sync request
    // not setting timeout on the xhr object, because of old webkits etc. not handling that correctly
    // both npm's request and jquery 1.x use this kind of timeout, so this is being consistent
    if (!sync && options.timeout > 0 ) {
        timeoutTimer = setTimeout(function(){
            if (aborted) return
            aborted = true//IE9 may still call readystatechange
            xhr.abort("timeout")
            var e = new Error("XMLHttpRequest timeout")
            e.code = "ETIMEDOUT"
            errorFunc(e)
        }, options.timeout )
    }

    if (xhr.setRequestHeader) {
        for(key in headers){
            if(headers.hasOwnProperty(key)){
                xhr.setRequestHeader(key, headers[key])
            }
        }
    } else if (options.headers && !isEmpty(options.headers)) {
        throw new Error("Headers cannot be set on an XDomainRequest object")
    }

    if ("responseType" in options) {
        xhr.responseType = options.responseType
    }

    if ("beforeSend" in options &&
        typeof options.beforeSend === "function"
    ) {
        options.beforeSend(xhr)
    }

    // Microsoft Edge browser sends "undefined" when send is called with undefined value.
    // XMLHttpRequest spec says to pass null as body to indicate no body
    // See https://github.com/naugtur/xhr/issues/100.
    xhr.send(body || null)

    return xhr


}

function getXml(xhr) {
    // xhr.responseXML will throw Exception "InvalidStateError" or "DOMException"
    // See https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/responseXML.
    try {
        if (xhr.responseType === "document") {
            return xhr.responseXML
        }
        var firefoxBugTakenEffect = xhr.responseXML && xhr.responseXML.documentElement.nodeName === "parsererror"
        if (xhr.responseType === "" && !firefoxBugTakenEffect) {
            return xhr.responseXML
        }
    } catch (e) {}

    return null
}

function noop() {}


/***/ }),

/***/ 996:
/***/ (function(module, exports) {

module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}


/***/ })

});


// WEBPACK FOOTER //
// 4.a8d4d8e33ac91a92f228.js